import { observable, action, flow, computed, toJS, runInAction } from 'mobx';
import Util from 'utils';
import React from 'react';
import Config from 'config/Config';
import { Toast, Modal, Flex } from 'antd-mobile';
import Stores from 'config/Stores';
import _, { get, cloneDeep, isEmpty } from 'lodash';
import { rstr2b64 } from 'utils/md5';
import cx from 'classnames';
import * as _reactDom from 'react-dom';
import { floatTool } from 'utils/math';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import {
  activityTypeMap,
  advanceSaleStatusMap,
  groupActionTypeMap,
  advanceSaleTypeMap,
  activityTipTitleMap,
  contentTipPosTypeMap,
  CouponTypeMap,
  internationalFreightTypeMap
} from 'utils/constants';
import Serv from './CheckOrderServ';
import './CheckOrderLess.less';
import { getIsUnsubscribeOrSleep } from 'biz-micro-services-ui/project/middlePlatform/function/globalState';

const { CDN_BASE } = Config;
const { alert } = Modal;
const getInfoSign = 1;

const defaultOrderInfo = {
  freightAmount: 0,
  itemNumber: 0,
  orderBv: 0,
  totalAmount: 0,
  couponsAmount: 1,
  // 顺手买一单的商品运费
  easeBuyFreight: 0,
  // 材料费
  extraFreight: 0
};

// 优惠券信息
const couponInfo = {
  addressId: '', // 对应地址id
  usableCount: 0, // 可用数量
  usableList: [], // 可用列表
  unUsableCount: 0, // 不可用数量
  unUsableList: [], // 不可用列表
  mustUseNumber: 0 // 优惠券必须使用数量
};

class CheckOrderMod {
  @observable type = '';

  // 卡类型id
  @observable cardTypeId = '';

  // 是否显示返回修改提货产品提示
  @observable isTakeDelivery = false;

  // 1：个人收货，2：自提，3：店铺代收
  @observable deliveryType = '';

  // 后台返回可用的配送方式列表
  @observable deliveryList = [];

  // 用户选择的收货地址
  @observable deliveryAddress = null;

  // 后台返回的核对订单信息
  @observable orderInfo = defaultOrderInfo;

  // 默认的所属店铺be
  @observable defaultBelongShop = '';

  // 用户编辑的所属店铺
  @observable belongShop = '';

  // 用户编辑的所属店铺编号是否正确
  @observable availableBelongShop = false;

  // 后台返回的清单列表
  @observable itemList = [];

  // 后台返回的赠品清单列表
  @observable giveawayInfoList = [];

  // 附属赠品
  @observable accessoryGift = [];

  // 结算类型：'1'零售订单 '2'复消订单 '3'自主开卡 '4'会员自主升级 '5'会员新客注册 '6'申请开店 '7'店铺新客注册 '8'店铺老客升级。 '9': 维多益站点会员代客升级 '10': vip复购 '18': 虚拟资格需要订单开卡
  @observable orderType = '1';

  @observable orderProperty = '1';

  @observable hasRequest = false;

  @observable discount = '';

  @observable isVipRebuy = false;

  // 干细胞-表单
  @observable isCellMode = false;

  // 店长物料 1:3
  @observable isShopMasterMode = false;

  // 自提信息
  @observable pickUpInfo = {};

  // 店铺信息
  @observable storeInfo = {};

  // 店铺名称
  @observable shopName = '';

  // 多条件 是否开启店铺代收
  @observable storeCollection = false;

  // 活动下单结果
  @observable activityOrderResult = null;

  // 代客下单会员信息(可用该字段是否有值来判断是否是代客下单)
  @observable dgMemberInfo = null;

  // 秒杀拼团预售活动信息
  @observable activityInfo = null;

  // 新客注册、升级、下单等顾客 卡号和id

  @observable dgCardCode = '';

  @observable dgUserId = '';

  // 是否需要填写资格购表单
  @observable needForm = false;

  // 资格购填写信息
  @observable ziGedataType = '1';

  @observable ziGeMemberName = '';

  @observable ziGePartnerName = '';

  @observable ziGeday = '';

  @observable isSelected = true;

  // 资格购-干细胞表单
  @observable cellsForm = [];

  // 鹰眼检测信息
  @observable hawkEyeTestInfo = [];

  // 未点击修改鹰眼信息的数组下标
  @observable valueList = [];

  isShowConfirmTip = false;

  @observable ziGeCertificateName = '';

  // 优惠券
  @observable couponInfo = cloneDeep(couponInfo);

  // 运费券
  @observable freightCouponInfo = cloneDeep(couponInfo);

  @observable deduction = []; // 已选抵扣劵列表

  // 已选的优惠券列表（在couponInfo.usableList列表的index索引）
  @observable selectedCoupons = [];

  // 已选的运费券（freightCouponInfo.usableList列表的index索引）
  @observable selectedFreightCoupon = -1;

  tmpFreightIdx = -1;

  // 是否隐藏优惠券
  @observable isHideCoupon = false;

  // 资格购是否可用优惠券
  @observable qualifyCoupon = false;

  // 活动类型 0:普通 1:满减 2:满赠实物 3:满赠券 4:满减权益 5:折扣 6:加价购 7:预售 8:拼团 9:秒杀
  @observable activityType = 0;

  // 团购类型
  @observable groupActionType = 1;

  // 预售状态
  @observable advanceSaleStatus = advanceSaleStatusMap.PAYFORDEPOSIT;

  // 活动id
  activityId = '';

  // 拼团订单号
  @observable groupOrderId = '';

  // 交易号 （预售尾款）
  @observable tradeNo = '';

  // 用于店铺运费提示时，展示的运费
  @observable freightAmountForShow = 0;

  // 是否同意协议
  @observable isAgree = false;

  // 合同协议的code
  @observable agreenMentCode = '';

  // 合同的标题
  @observable agreementTitle = '';

  // 控制弹框
  @observable visible = false;

  // 开卡满减额外携带参数
  @observable newItemResDtos = {};

  // 判断是否是返回到当前页面 如果是 不请求地址信息
  @observable oldparam = '';

  @observable tagStatus = 0;

  @observable belongArea = '';

  @observable sale = '';

  @observable confirmParams = {};

  // 是否为甄选订单
  isFromSelectMall = false;

  @observable hideOrderTypeListAndDiscountMode = true;

  // 选中的子活动id
  @observable subActivityId = '';

  // 选中的子活动Code
  @observable subCardCode = '';

  @observable showOrderRemark = false;

  @observable orderRemark = '';

  // 是否批量购物模式的资格购活动
  @observable isShoppingPatterns = false;

  // 是否为嘉年华锅具
  @observable isSpecial = false;

  @observable isSpecialBv = 0;

  @observable showModifyServiceCenter = 0;

  // 享包邮产品
  @observable freeShippingItem = [];

  // 是否为乐道大单的确认订单
  ldOrder = false;

  // 乐道大单的注册信息
  ldRegisterCardReqDto = {};

  // 乐道大单type 1.自主开卡，2.自主升级，3.代客开卡，4.代客升级
  type = '';

  // 记录生日下单
  birthday = '';

  // 固定bv
  bvReceiveData = {
    bv: null,
    bvMode: null,
    upgradePriceDifference: null,
    reduceBv: null
  };

  // 特殊产品编号需要展示特定的收货地址(致道升级开卡场景)
  specialAddressProductCode = [];

  // 内容提醒
  confirmTip = [];

  // 顺手买一单商品列表
  @observable easeBuyItemList = [];

  @observable easeBuyItemIndex = 0;

  // 是否是代客下单
  @observable isDgUserid = false;

  // 是否续约礼订单
  @observable renewGiftOrderFlag;

  // 是否为三生豆订单
  isBean = false;

  // 入口名称，仅用于生命周期埋点
  @observable inletTitle = '';
  // 来源标签，记录订单来源链路
  @observable sourceTag = '';

  // 店主专享福利分享人
  @observable invitationUserId = '';

  // 是否是店主福利专区传入
  @observable isCarnival = false;

  // confirm接口返回的参数
  confirmReturnData = {};

  // 个人礼品仓 配置项
  @observable giftWarehouseConfig = {};

  // 薇美云仓(新仓) 配置项
  @observable newWarehouseConfig = {};
  // 开方单号
  @observable sourceNo = '';
  @observable purchaseQuantity = 0;
  // 顺手买一单code
  @observable easyBuyCode = '';
  @observable isXBLPickUpGoods = false;

  @observable pickUpSelfAddress;

  // 国际运费类型 1-直接补  2-包邮订单
  @observable internationalFreightType = '';

  defaultAddressInfo = {}; // 外部带入的地址

  @observable freeShippingNo = ''; // 国际运费享包邮订单的主单号

  @observable globalSaleMode = ''; // 2-销售专区 3-消费专区

  // 是否为宫主会订单
  @observable isPriaItem = false;
  // 是否享考察活动
  @observable isXkcActivity = false;

  @observable showModifyServiceCenter = 0;

  @observable detectionModal = { visible: false, tip: '' }; // 是否展示AI检测充值的弹窗

  detectionRechargeCardCode = ''; // AI检测充值的卡号

  checkOrderData = {};

  // 顺手买一单是否显示原价 0 不显示 1 显示
  @observable originalPriceDisplay = 0;

  // 顺手买一单入参记录，用于后续接口调用
  @observable easeBuyParams = {};
  @observable easeBuyModalVisible = false; // 顺手买一单弹窗

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  // 是否代客
  @computed
  get isMemberDg() {
    if (this.dgMemberInfo && this.dgMemberInfo.memberCard) {
      return true;
    } else {
      return false;
    }
  }

  // 是否展示国际物流运费类型
  @computed
  get isShowInterNationalFreightWay() {
    const userInfo = Stores.AppMod.userInfo;
    const { isInternational } = this.deliveryAddress || {};
    // 1-个人收货
    // 2-个人收获地址是不是海外地址 isInternational
    // 3-是否国际化版本 isInternationalized
    // 4-享包邮订单 freeShippingNo
    return (
      this.deliveryType == '1' &&
      isInternational === 1 &&
      Stores.AppMod.isInternationalized &&
      !this.freeShippingNo &&
      !(Stores.AppMod.internationalConfig || {}).hideSupplementFreight
    );
  }

  @computed
  get dgAreaCode() {
    // 销售专区
    if (this.globalSaleMode == 2) {
      return (
        (this.dgMemberInfo && this.dgMemberInfo.areaCode) || localStorage.getItem('dgAreaCode')
      );
    }

    // 4-会员代客升级  8-店铺代客升级
    if (this.orderType == 8 || this.orderType == 4) {
      // 会员代客升级/店铺代客升级
      const upgradeCardInfo = Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember);
      return upgradeCardInfo && upgradeCardInfo.areaCode;
    }

    if (this.orderType == 5) {
      // 会员代客注册
      const registerCardReqDto = Util.getLocalCache(
        Config.localStorageKeys.member_agentApplyCardMsg
      );
      return registerCardReqDto && registerCardReqDto.areaCode;
    }

    if (this.orderType == 7) {
      // 店铺代客注册
      const info = Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
      return info && info.areaCode;
    }

    if (this.isDgUserid) {
      // 代客下单
      return (
        (this.dgMemberInfo && this.dgMemberInfo.areaCode) || localStorage.getItem('dgAreaCode')
      );
    }
  }

  // 收货方式是否可编辑
  @computed
  get isDeliveryInfoDisabled() {
    return !!this.freeShippingNo;
  }

  // 提交订单页是否展示BV
  @computed
  get isShowBV() {
    // 老鹰体系和享包邮订单不展示BV
    return !['LY'].includes(Stores.AppMod.userInfo.belongSystem) && !this.freeShippingNo;
  }

  /**
   * @description 过滤重复活动
   * @param {*} newItemResDtos
   * @returns
   */
  filteractivity(newItemResDtos) {
    const nel = (newItemResDtos || []).map((rt) => {
      const { activityIdList = [] } = rt || {};
      const lt = [...new Set(activityIdList || [])];
      rt.activityIdList = cloneDeep(lt) || [];
      return rt;
    });
    return nel || [];
  }

  checkShuldDecypt(v) {
    if (!v) return false;
    return v.indexOf('*') != -1;
  }

  async getDecyptMsgInfo({ type, value }) {
    const typeParam = {
      phone: {
        id: this.dgUserId || Stores.AppMod.userInfo.id,
        scene: 206,
        channel: ''
      },
      name: {
        id: this.dgUserId || Stores.AppMod.userInfo.id,
        scene: 101,
        channel: ''
      }
    };
    const v =
      (this.checkShuldDecypt(value) && (await Stores.AppMod.getDecyptMsg(typeParam[type]))) ||
      value;
    return v;
  }

  @action
  resetCouponInfo() {
    this.couponInfo = cloneDeep(couponInfo);
    this.freightCouponInfo = cloneDeep(couponInfo);
    console.log(this.freightCouponInfo, 'this.freightCouponInfo');
    this.selectedCoupons = [];
    this.selectedFreightCoupon = -1;
    this.tmpFreightIdx = -1;
  }

  /**
   * 重置优惠券选中信息
   */
  @action
  resetCouponSelectData = () => {
    // 兑换券无需清空
    const usableList = this.couponInfo.usableList || [];
    const isExchange = (this.selectedCoupons || []).some((selectIndex) => {
      const selectItem = usableList[selectIndex] || {};
      return selectItem.couponType === CouponTypeMap.EXCHANGE;
    });
    if (isExchange) return;
    this.selectedCoupons = [];
    this.selectedFreightCoupon = -1;
    this.tmpFreightIdx = -1;
  };

  @computed
  get selectCouponList() {
    const usableList = (this.couponInfo && this.couponInfo.usableList) || [];
    return this.selectedCoupons.map((selectIndex) => usableList[selectIndex]);
  }

  @computed
  get selectFreightCouponList() {
    const usableList = (this.freightCouponInfo && this.freightCouponInfo.usableList) || [];
    const selectItem = usableList[this.selectedFreightCoupon];
    return selectItem ? [usableList[this.selectedFreightCoupon]] : [];
  }

  @action
  switchCoupon(index) {
    const { freightAmount } = this.orderInfo;
    let list = [...this.selectedCoupons];
    console.log('listlistlistlist', list);
    let coupon = this.couponInfo.usableList[index];
    console.log('couponcouponcoupon', coupon);
    if (list.length && !list.includes(index)) {
      let oldCoupon = this.couponInfo.usableList[list[0]];
      // 0门槛 + 券开启了允许叠加 + 同类型的券才可以叠加使用
      let noAllow = oldCoupon.thresholdAmount != 0 || oldCoupon.useSuperimposedType != 1;
      noAllow =
        noAllow ||
        !(
          coupon.thresholdAmount == 0 &&
          coupon.useSuperimposedType == 1 &&
          coupon.couponType == oldCoupon.couponType
        );
      // &&
      // !(
      //   // 抵扣券 每满 同一个券模版  门槛金额小于等于商品价格 同门槛
      //   coupon.couponType === 1 &&
      //   coupon.thresholdAmountType == 1 &&
      //   coupon.couponTemplateId === oldCoupon.couponTemplateId &&
      //   coupon.thresholdAmount >= freightAmount &&
      //   coupon.thresholdAmount === oldCoupon.thresholdAmount
      // );
      if (noAllow) {
        Toast.info('已选优惠券不可和该优惠券叠加使用');
        return;
      }
    }
    if (!list.includes(index)) {
      // 总金额减到0了，就不允许继续多选券
      if (this.payAmount - freightAmount <= 0) {
        Toast.info('当前订单已达该券使用上限，不可再使用');
        return;
      }
      // 该券是指定产品券，若指定的所有商品都已经把金额减到0了，就不允许选择该券
      if (coupon.itemRange != 1 && coupon.itemRange != 6) {
        for (let item of coupon.itemIdList) {
          let product = this.productList.find((product) => product.itemSerial == item);
          if (product && Math.round(product.realMoney * 100) / 100 != 0) break;
          else if (product) {
            Toast.info('当前订单已达该券使用上限，不可再使用');
            return;
          }
        }
      }
      list.push(index);
      if (coupon.couponType == 1) {
        this.deduction.push(coupon);
      }
    } else {
      list.splice(list.indexOf(index), 1);
      if (coupon.couponType == 1) {
        let findIndex = this.deduction.findIndex((item) => item.id == coupon.id);
        // console.log('findIndexfindIndex',findIndex)
        this.deduction.splice(findIndex, 1);
      }
    }
    this.selectedCoupons = list;
  }

  @action
  sortClass(sortData) {
    const groupBy = (array, f) => {
      let groups = {};
      array.forEach((o) => {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const sorted = groupBy(sortData, (item) => {
      return item.couponTemplateId; // 返回需要分组的对象
    });
    return sorted;
  }

  // 选中默认运费优惠券
  @action
  setDefaultFreightCoupon(index) {
    if (this.freightCouponInfo.usableList.length > index) {
      let coupon = this.freightCouponInfo.usableList[index];
      let afterFreight =
        Math.round((this.orderInfo.originFreightAmount - coupon.couponValue) * 100) / 100;
      if (coupon.deductionWay == 2) afterFreight = 0;
      if (!coupon.disabled) {
        this.selectedFreightCoupon = index;
        this.orderInfo.freightAmount = afterFreight < 0 ? 0 : afterFreight;
      }
    }
  }

  @action
  selecteFreightCoupon(index) {
    const { freightAmount } = this.orderInfo;
    if (freightAmount <= 0 && this.selectedFreightCoupon == -1) {
      Toast.info('当前订单无运费，无需抵扣');
      return;
    }
    this.selectedFreightCoupon = this.selectedFreightCoupon != index ? index : -1;
    if (this.selectedFreightCoupon >= 0) {
      let coupon = this.freightCouponInfo.usableList[index];
      let afterFreight =
        Math.round((this.orderInfo.originFreightAmount - coupon.couponValue) * 100) / 100;
      if (coupon.deductionWay == 2) afterFreight = 0;
      this.orderInfo.freightAmount = afterFreight < 0 ? 0 : afterFreight;
    } else {
      this.orderInfo.freightAmount = this.orderInfo.originFreightAmount;
    }
    this.orderInfo = toJS(this.orderInfo);
  }

  // 资格购-干细胞
  @action
  cellsChange(value, type, index) {
    let formValue = toJS(this.cellsForm);
    const currenActivityItem = formValue[index];
    if (currenActivityItem) {
      currenActivityItem[type] = value;
    }
    formValue[index] = currenActivityItem;
    this.cellsForm = formValue;
  }

  // 鹰眼检测信息
  @action
  hawkEyeChange(value, type, index) {
    let formValue = toJS(this.hawkEyeTestInfo);
    let cellsFormValue = toJS(this.cellsForm);
    let ActivityItem = formValue[index];
    if (ActivityItem) {
      ActivityItem[type] = value;
    } else {
      ActivityItem = {};
      ActivityItem[type] = value;
    }
    formValue[index] = ActivityItem;
    this.hawkEyeTestInfo = formValue;
    cellsFormValue[index].hawkEyeTestInfo = ActivityItem;
    this.cellsForm = cellsFormValue;
  }

  // 全是虚拟商品时 不显示配送方式 3 虚拟组合产品 4 虚拟产品
  @computed
  get isAllVirtualGoods() {
    const isAllVirtualGoods = this.productList.every((item) => [3, 4].includes(item.itemType));
    if (isAllVirtualGoods) {
      return true;
    }
    return false;
  }

  /**
   * 拼团/预售 获取活动信息
   * @param activityId 活动id
   * @param itemId 商品id
   */
  getActivityInfo = flow(function* (activityId, itemId) {
    try {
      const { data } = yield Serv.getActivityInfo(activityId, itemId);
      this.activityInfo = data;

      // 预售
      if (this.activityInfo.activityType === activityTypeMap.advanceSale) {
        this.prepareAdvanceInfo();
      }
    } catch (e) {}
  });

  /**
   * 控制显示隐藏店铺代收
   */
  validStoreCollection = flow(function* () {
    try {
      const { data } = yield Serv.validStoreCollection();
      this.storeCollection = data;
    } catch (e) {}
  });

  /**
   * 获取协议code
   */
  getProtocolByItems = flow(function* () {
    try {
      const itemIds = this.itemList.map((item) => item.itemSerial);
      const { data } = yield Serv.getProtocolByItems({ itemIds });
      if (data) {
        const itemProtocol = data.find((item) => item.protocol);
        this.agreenMentCode = itemProtocol && itemProtocol.protocol;
        if (this.agreenMentCode) {
          this.getAgreement(this.agreenMentCode);
        }
      }
    } catch (e) {}
  });

  /**
   * 获取生命银行
   */
  getAgreement = flow(function* (code) {
    if (!code) return;
    try {
      const { data } = yield Serv.getAgreement(code);
      this.agreementTitle = data.title;
    } catch (error) {}
  });

  renderPopup = (resultMsg, sign) => {
    let div = window.document.getElementById(sign);
    _reactDom.render(
      <Flex
        className="checkOrder-activity-tip-modal"
        justify="center"
        direction="column"
        alignContent="center">
        <Flex
          className="checkOrder-activity-content-modal"
          justify="center"
          direction="column"
          alignContent="center">
          <Flex className="checkOrder-activity-title-content-modal">
            您选购的商品未满足活动条件
          </Flex>
          <Flex className="checkOrder-activity-tip-content-modal">{resultMsg}</Flex>
          <Flex
            justify="center"
            direction="column"
            alignContent="center"
            className="checkOrder-activity-tip-confirm-modal"
            onClick={() => {
              _reactDom.render(<div />, div);
            }}>
            我已知晓
          </Flex>
        </Flex>
      </Flex>,
      div
    );
    // return (
    //   <Modal
    //     className = 'checkOrder-activity-queue-modal'
    //     popup
    //     transparent
    //     visible = {this.visible}
    //     onClose = {this.visible = false}>
    //     <Flex className = 'title'>
    //       <span className = 'belongShop'>修改所属店铺</span>
    //     </Flex>
    //     <Flex justify = 'around' className = 'title'>
    //       <span className = 'cancel' onClick = {this.close}>取消</span>
    //     </Flex>
    //   </Modal>
    // );
  };

  /**
   * 不满足的活动 + 支持1：2提示
   * suport1to2 是否支持1：2
   */
  notSatisfiedModal = ({
    extFields = {},
    productDetailMod,
    checkParams = {},
    getInfo,
    sign,
    objectValue,
    ignoreError = false,
    ment = null,
    activityLink = null,
    addActivityId = null,
    suport1to2 = false
  }) => {
    console.log('12312312', checkParams.items);
    const { errorActivityIdList = [], errorMsgList = [], notTriggerPopupIdList = [] } = extFields;
    // 判断有没有要弹窗的活动
    const noError = (errorActivityIdList || []).every((activityId) =>
      (notTriggerPopupIdList || []).includes(activityId)
    );
    const container = document.createElement('div');
    (checkParams.items || []).forEach((productItem) => {
      productItem.activityIdList = (productItem.activityIdList || []).filter((activityId) => {
        return !(errorActivityIdList || []).includes(activityId);
      });
    });
    (checkParams.bizGiveawayReqDto || {}).freeItem = (
      (checkParams.bizGiveawayReqDto || {}).freeItem || []
    ).filter((freeItem) => {
      return !(errorActivityIdList || []).some((item) =>
        (freeItem.activityIdList || []).includes(item)
      );
    });
    (checkParams.bizGiveawayReqDto || {}).giftList = (
      (checkParams.bizGiveawayReqDto || {}).giftList || []
    ).filter((giftItem) => {
      return !(errorActivityIdList || []).some((item) =>
        (giftItem.activityIdList || []).includes(item)
      );
    });
    (checkParams.bizGiveawayReqDto || {}).cheapItem = (
      (checkParams.bizGiveawayReqDto || {}).cheapItem || []
    ).filter((cheapItem) => {
      // 下单时 传了选的加价购活动id 用于过滤
      if (cheapItem.activityId) {
        cheapItem.activityIdList = cheapItem.activityIdList.filter(
          (activityId) => !(errorActivityIdList || []).includes(activityId)
        );
        return !(errorActivityIdList || []).includes(cheapItem.activityId);
      }
      return !(errorActivityIdList || []).some((item) =>
        (cheapItem.activityIdList || []).includes(item)
      );
    });
    // 不提示活动
    if (noError && (errorMsgList || []).length > 0) {
      this.confirmOrder(
        {
          ...checkParams,
          suport1to2: false
        },
        getInfo,
        sign,
        objectValue,
        ignoreError,
        ment,
        activityLink,
        addActivityId
      );
      return;
    }
    _reactDom.render(
      <Modal visible transparent className="not-satisfied-modal">
        <div className="not-satisfied-modal-content">
          {errorActivityIdList && errorActivityIdList.length ? (
            <p className="title">
              您选购的商品未满足下列活动条件
              <br />
              继续下单将无法参与下列活动
            </p>
          ) : (
            <p className="suport1to2Title">温馨提示</p>
          )}
          {(errorMsgList || []).map((text) => {
            return <p className="activity-desc">{text}</p>;
          })}
          {suport1to2 && (
            <p className="activity-desc" style={{ marginTop: '0.32rem' }}>
              当前订单可参加1:2配货, 当前下单选择的为1:1配货, 如需更换请返回调整
            </p>
          )}
          <Flex
            justify="between"
            style={{
              marginTop: '0.4rem'
            }}>
            <CommonBtn
              title="返回修改"
              className="back-btn"
              onClick={() => {
                _reactDom.unmountComponentAtNode(container);
                productDetailMod &&
                  productDetailMod.changeState({
                    showSpecModal: true
                  });
              }}
            />
            <CommonBtn
              title="提交订单"
              className="submit-btn"
              onClick={() => {
                _reactDom.unmountComponentAtNode(container);
                this.confirmOrder(
                  {
                    ...checkParams,
                    suport1to2: false
                  },
                  getInfo,
                  sign,
                  objectValue,
                  ignoreError,
                  ment,
                  activityLink,
                  addActivityId
                );
              }}
            />
          </Flex>
        </div>
      </Modal>,
      container
    );
  };

  /**
   * 乐道大单单独的confirm接口，单独的接口
   *
   * type 1.自主开卡，2.自主升级，3.代客开卡，4.代客升级
   *
   * orderType '1'零售订单 '2'复消订单 '3'自主开卡 '4'会员自主升级/会员代客升级 '5'会员新客注册 '6'申请开店 '7'店铺新客注 册 '8'店铺老客升级。 '9': 维多益站点会员代客升级
   *
   */
  confirmLDOrder = flow(function* (exParams) {
    const { type, inletTitle = '' } = exParams || {};
    try {
      this.ldOrder = true;
      const url = 'user/largeOrder/confirm';
      const itemCode = Util.getLocalCache('ldorder_itemcode');
      const userInfo = Stores.AppMod.userInfo || {};
      const userType = userInfo.userType;
      const isShop = userType >= 3;
      const params = {
        type,
        itemCode
      };
      this.type = params.type;
      this.hideOrderTypeListAndDiscountMode = false;

      const registerCardReqDto = Util.getLocalCache(
        Config.localStorageKeys.member_agentApplyCardMsg
      );

      const storeRegisterCardReqDto = Util.getLocalCache(
        Config.localStorageKeys.member_storeAgentApplyCardMsg
      );

      // 自主开卡
      if (type === 1) {
        params.registerCardReqDto = registerCardReqDto;
        this.orderType = '3';
      }

      // 自主升级
      if (type === 2) {
        this.orderType = '4';
      }

      // 会员代客开卡
      if (type === 3 && !isShop) {
        params.registerCardReqDto = registerCardReqDto;
        this.orderType = '5';
        this.dgUserId = registerCardReqDto.helpUserId;
      }

      // 店铺代客开卡
      if (type === 3 && isShop) {
        params.registerCardReqDto = storeRegisterCardReqDto;
        this.orderType = '7';
        this.dgUserId = storeRegisterCardReqDto.helpUserId;
      }

      // type 会员代客升级 店铺代客升级
      if (type === 4) {
        const upgradeCardInfo = Util.getLocalCache(
          Config.localStorageKeys.store_agentUpgradeMember
        );
        this.dgCardCode = upgradeCardInfo.cardCode;
        this.dgUserId = upgradeCardInfo.dgUserId;
        console.log('🍈===>', this.dgCardCode, this.dgUserId);
        this.orderType = isShop ? '8' : '4';
        params.registerCardReqDto = { helpUserId: this.dgUserId };

        const checkOrderParams = Util.getLocalCache(Config.localStorageKeys.shop_checkOrderParams);

        if (checkOrderParams) {
          Object.keys(checkOrderParams).forEach((key) => {
            this[key] = checkOrderParams[key];
          });
        }
      }

      if (params.registerCardReqDto) {
        // 提交订单的时候需要回传使用
        this.ldRegisterCardReqDto = params.registerCardReqDto;
      }

      const { data, resultCode, resultMsg } = yield Serv.confirmLDOrder(url, params);

      if (resultCode === '0') {
        this.tagStatus = 0;

        // 正常返回
        this.giveawayInfoList = data.giveawayInfoList || [];

        Util.setLocalCache(Config.localStorageKeys.shop_confirmItems, JSON.stringify(data.items));
        Util.setLocalCache(Config.localStorageKeys.shop_orderType, this.orderType);
        Util.setLocalCache(Config.localStorageKeys.shop_orderProperty, '1');
        Util.setLocalCache(Config.localStorageKeys.shop_orderDiscount, '');
        Util.setLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto, {});
        Util.setLocalCache(Config.localStorageKeys.shop_couponAutoSelect, {});

        this.orderProperty = '1';
        this.discount = '';

        // 请求运费券
        let ids = (data.activityDiscountInfo || []).map((item) => item.activityId);
        this.getFreightCouponList(ids.join(','), { items: data.items });

        // 资格购是否可用优惠券
        (data.activityDiscountInfo || []).map((item) => {
          if (item.superimposCoupon == 0) {
            this.qualifyCoupon = true;
          }
        });

        delete data.freightAmount;
        Object.assign(this.orderInfo, data);
        this.defaultBelongShop = data.shopCode;
        this.belongShop = data.shopCode;
        this.shopName = data.realName || '';
        this.availableBelongShop = true;
        this.itemList = data.items;
        this.needForm = data.form;
        if (data.formType == 'stemCells') {
          this.isCellMode = true;
          let list = Array(...{ length: data.writeNum });
          list.forEach((item) => {
            this.cellsForm.push(
              observable({
                name: '',
                identityCard: '',
                formType: data.formType
              })
            );
          });
        }

        if (!Array.of(3, 4, 5, 6, 7, 8).includes(+this.orderType)) {
          Toast.loading('请稍候', 0);
          yield this.getDeliverys();
          yield this.getLogistics();
          Toast.hide();
        }

        window.app.routerGoTo({
          pathname: `/shop/checkOrder`,
          state: {
            ment: null,
            activityLink: null,
            inletTitle
          }
        });
      }
    } catch (err) {}
  });

  /**
   * 请求参数处理
   */
  calParmas = ({ val, params } = {}) => {
    //   sessionStorage.getItem('subActivityId') &&
    //   (params.subActivityId =
    //     sessionStorage.getItem('subActivityId') || '');
    // sessionStorage.getItem('cardCode') &&
    //   (params.subCardCode = sessionStorage.getItem('cardCode') || '');
    // sessionStorage.getItem('subActivityChannel') &&
    //   (params.subActivityChannel =
    //     sessionStorage.getItem('subActivityChannel') || '');
    if (Array.isArray(val)) {
      val.forEach(({ key, value }) => {
        sessionStorage.getItem(value) && (params[key] = sessionStorage.getItem(value));
      });
    } else {
    }
    this.directPayFreight && (params.directPayFreight = this.directPayFreight);
    const $params = this.getMoreParams(params);
    return $params;
  };

  /**
   * @description 获取附属赠品
   */
  fetchAccessoryGift = flow(function* (params) {
    try {
      const { data } = yield Serv.getAccessoryGift(params);
      this.accessoryGift = data;
    } catch (e) {}
  });

  /**
   * 当前订单产品是否包含特殊产品
   *
   * @memberof CheckOrderMod
   */
  getHasSpecialProduct = () => {
    if (this.specialAddressProductCode.length) {
      const itemList = this.itemList || [];
      const hasSpecialProduct = itemList.some((item) => {
        return this.specialAddressProductCode.includes(item.code);
      });
      return hasSpecialProduct;
    }
    return false;
  };

  /**
   * 致道开卡和升级场景，购买特定的产品需要用特性的地址
   *
   * @memberof CheckOrderMod
   */
  getSpecialProductCodeList = async (orderType) => {
    // 自主开卡 3，会员代客开卡5   店铺代客开卡 7  自主升级 4   会员代客升级 4   店铺代客升级 8
    const openCardUpgradeOrderTypeList = ['3', '5', '4', '7', '8'];

    // 致道开卡和升级场景，购买特定的产品需要用特性的地址
    const isSpecialProductOrderType = openCardUpgradeOrderTypeList.includes(orderType.toString());

    if (isSpecialProductOrderType) {
      try {
        // 请求特定产品数据
        const data = await Serv.specialProductCode();
        this.specialAddressProductCode = data || [];
      } catch (err) {}
    }
  };

  /**
   * 核对订单信息-进入提交订单页时调用
   * @param items
   * @param orderType 订单类型
   * @param orderProperty 配送比例
   */
  confirmOrder = flow(function* (
    checkParams,
    getInfo,
    sign,
    objectValue,
    ignoreError = false,
    ment = null,
    activityLink = null,
    addActivityId = null
  ) {
    localStorage.setItem('saveInfo', 0);
    const { hideOrderTypeListAndDiscountMode = false } = objectValue || {};
    this.hideOrderTypeListAndDiscountMode = hideOrderTypeListAndDiscountMode; // 设置是否隐藏配货比例和订单类型列表
    console.log(checkParams, '---checkParams--->');
    let {
      // cloudStorageTag = 0 , //云仓标识
      items = [],
      orderType = '1',
      orderProperty = '1',
      activityType = 0,
      activityId = '', // 活动id
      itemId, // 商品id
      bizGiveawayReqDto = {},
      toastThrough = false,
      tradeNo = null,
      discount = '',
      coupon = {},
      isVipRebuy,
      isShopMasterMode,
      newItemResDtos,
      bvData = {},
      subActivityObj = {},
      $cardTypeId,
      $supplementInfo,
      isSelectMall,
      applyUserInfo = null,
      isDG = false,
      renewGiftOrderFlag = '',
      multiActivityValidateFlag = false,
      productDetailMod = null,
      inletTitle = '',
      sourceTag = '',
      // 是否支持1：2
      suport1to2 = false,
      isTakeDelivery = false,
      directPayFreight = 0, // 是否是直接付运费 0 不支付 1 支付
      goodsCouponTag = '',
      // 开方单号
      sourceNo = '',
      // 来源渠道，0-其它、1-异业商城、2-权益仓库-入、3-权益仓库-出,4, 专家在线开方
      sourceChannel = '',
      isXBLPickUpGoods = false,
      globalSaleMode = '', // 产品属性
      dreamPlanRelateCard = '', // 助梦计划cardCode
      freeShippingNo = '', // 享包邮主单单号
      shopCart = '',
      isPriaItem = false, // 是否来自宫主会
      isMb = '',
      voucherInfo = {},
      isXkcActivity = false,
      invitationUserId = '', // 特殊场景分享用户id
      applyMaterial = '', //  需要完善申请资料(店铺信息) 1
      needCertificationList = [],
      checkName = ''
    } = checkParams;
    console.log('globalSaleMode112', globalSaleMode);
    // 临时去重
    items = (items || []).map((val) => {
      return {
        ...val,
        activityIdList: [...new Set(val.activityIdList)]
      };
    });

    this.isTakeDelivery = isTakeDelivery;
    this.directPayFreight = directPayFreight;
    this.cardTypeId = $cardTypeId;
    this.bvReceiveData = bvData;
    this.newItemResDtos = newItemResDtos;
    this.isFromSelectMall = isSelectMall;
    this.renewGiftOrderFlag = renewGiftOrderFlag;
    this.sourceNo = sourceNo;
    this.isXBLPickUpGoods = isXBLPickUpGoods;
    this.freeShippingNo = freeShippingNo;
    this.isPriaItem = !!isPriaItem;
    this.voucherInfo = voucherInfo;
    // 拼团或预售，获取活动信息
    if (
      [
        activityTypeMap.groupBuy,
        activityTypeMap.specialGroup,
        activityTypeMap.advanceSale,
        activityTypeMap.flashSale
      ].includes(activityType)
    ) {
      this.getActivityInfo(activityId, itemId);
    }
    this.isVipRebuy = isVipRebuy;
    this.isShopMasterMode = isShopMasterMode;
    this.tradeNo = tradeNo;
    this.activityType = activityType;
    this.activityId = activityId;

    console.log('---------orderType---', orderType);
    // 核对订单额外参数，统一放在shop_checkOrderParams里
    const checkOrderParams = Util.getLocalCache(Config.localStorageKeys.shop_checkOrderParams);
    console.log('confirmOrder66', checkOrderParams);
    if (checkOrderParams) {
      Object.keys(checkOrderParams).forEach((key) => {
        this[key] = checkOrderParams[key];
      });
    }

    if (coupon.id) {
      this.isHideCoupon = true;
      this.couponInfo = { ...couponInfo, usableList: [coupon] };
      this.selectedCoupons = [0];
    } else {
      this.isHideCoupon = false;
    }

    let url = '';
    let params = {};
    console.log('orderTypeorderTypeorderTypeorderType009', orderType);
    switch (orderType.toString()) {
      case '3': {
        // 自主申请开卡下单
        url = 'user/register/confirmRegisterCardOrder';
        let registerCardReqDto =
          Util.getLocalCache(Config.localStorageKeys.member_applyCardMsg) || {};
        params = {
          benefitReqDtos: items,
          confirmReqDto: {
            bizGiveawayReqDto,
            items: this.filteractivity(newItemResDtos || []),
            ...bvData
          },
          registerCardReqDto: {
            ...registerCardReqDto,
            ...(applyUserInfo
              ? {
                  healthConsultantNum: applyUserInfo.healthConsultantNum,
                  saleConsultantNum: applyUserInfo.healthConsultantNum,
                  realName: applyUserInfo.realName,
                  name: applyUserInfo.realName,
                  identityType: applyUserInfo.identityType,
                  identityCard: applyUserInfo.identityCard,
                  birthday: applyUserInfo.birthday,
                  sex: applyUserInfo.sex,
                  nation: applyUserInfo.nation
                }
              : {})
          }
        };
        if (multiActivityValidateFlag) {
          params.confirmReqDto.multiActivityValidateFlag = true;
        }
        if (sourceChannel == 11) {
          params.confirmReqDto.sourceChannel = sourceChannel;
        }
        break;
      }
      case '4': {
        // 会员自主升级下单
        const localMemInfo = Util.getLocalCache('store_agentUpgradeMember') || {};
        const memberForUpdate = Util.getLocalCache('memberForUpdate');
        url = 'user/upgrade/confirmUpgradeCardOrder';
        params = {
          benefitReqDtos: items,
          confirmReqDto: {
            bizGiveawayReqDto,
            items: this.filteractivity(newItemResDtos || []),
            ...bvData
          },
          bizUpgradeCardReqDto: {
            cardCode: memberForUpdate ? localMemInfo.cardCode : Stores.AppMod.userInfo.cardCode,
            channel: memberForUpdate ? 4 : 1
          }
        };
        if (multiActivityValidateFlag) {
          params.confirmReqDto.multiActivityValidateFlag = true;
        }
        break;
      }
      case '5': {
        // 会员新客注册订单
        url = 'user/register/confirmRegisterCardOrder';
        const registerCardReqDto =
          Util.getLocalCache(Config.localStorageKeys.member_agentApplyCardMsg) || {};
        params = {
          benefitReqDtos: items,
          confirmReqDto: {
            bizGiveawayReqDto,
            items: this.filteractivity(newItemResDtos || []),
            ...bvData
          },
          registerCardReqDto
        };
        if (this.dgMemberInfo) {
          // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
          // 如果是代客的话，按之前的逻辑，默认为 店铺代客
          params.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        if (multiActivityValidateFlag) {
          params.confirmReqDto.multiActivityValidateFlag = true;
        }
        break;
      }
      case '6': {
        // 申请开店订单
        const applyStoreMsg =
          Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg) || {};
        const { storeTypeId } = applyStoreMsg.shopContactInfoDto || {};
        url =
          applyStoreMsg.registerType == 0
            ? 'store/create/unregister/settle'
            : 'store/create/register/settle';
        params = {
          host: Config.HOST_STORE,
          confirmReqDto: {
            items,
            orderType: 5, // 后台开店订单类型对应为5
            bizGiveawayReqDto
          },
          storeCreateReqDto: applyStoreMsg,
          storeTypeId
        };
        break;
      }
      case '7': {
        // 店铺新客注册订单
        url = 'valetOpenCard/confirmValetOpenCardOrder';
        const storeAgentApplyCardMsg =
          Util.getLocalCache(Config.localStorageKeys.member_storeAgentApplyCardMsg) || {};
        params = {
          host: Config.HOST_STORE,
          benefitReqDtos: items,
          bizValetCardReqDto: storeAgentApplyCardMsg,
          confirmReqDto: {
            cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
            userId: Stores.AppMod.userInfo.id,
            channel: 2,
            bizGiveawayReqDto,
            items: this.filteractivity(newItemResDtos || []),
            ...bvData
          }
        };

        if (this.dgMemberInfo) {
          // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
          // 如果是代客的话，按之前的逻辑，默认为 店铺代客
          params.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        if (multiActivityValidateFlag) {
          params.confirmReqDto.multiActivityValidateFlag = true;
        }
        if (sourceChannel == 11) {
          params.confirmReqDto.sourceChannel = sourceChannel;
        }
        break;
      }
      case '8': {
        // 店铺老客升级订单
        url = 'valetUpgrade/confirmUpgradeCardOrder';
        const agentUpgradeMember =
          Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
        ignoreError = true;
        params = {
          host: Config.HOST_STORE,
          benefitReqDtos: items,
          bizUpgradeCardReqDto: {
            passengerCardCode: agentUpgradeMember.cardCode,
            channel: 3
          },
          confirmReqDto: {
            cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
            dgMemberCode: agentUpgradeMember.cardCode,
            dgMemberName: agentUpgradeMember.realName,
            // items,
            items: this.filteractivity(newItemResDtos || []),
            channel: 3,
            userId: Stores.AppMod.userInfo.id,
            bizGiveawayReqDto,
            ...bvData
          }
        };
        if (sourceChannel == 11) {
          params.confirmReqDto.sourceChannel = sourceChannel;
        }
        if (this.dgMemberInfo) {
          // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
          // 如果是代客的话，按之前的逻辑，默认为 店铺代客
          params.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        if (multiActivityValidateFlag) {
          params.confirmReqDto.multiActivityValidateFlag = true;
        }
        params.tag = this.tagStatus;
        break;
      }
      case '18': {
        // 虚拟资格需要订单开卡
        url = 'valetOpenCard/confirmValetOpenCardOrder';
        // const virtualApplyCardMsg = {
        //   healthConsultantNum: Stores.AppMod.userInfo.cardCode,
        //   helpUserId: Util.getLocalCache('virtualUserId'),
        //   channel: 2,
        //   isEntityCard: 0, // 0 虚拟卡 1 实体卡
        // }
        const virtualApplyCardMsg =
          Util.getLocalCache(Config.localStorageKeys.virtual_applyCardMsg) || {};
        params = {
          host: Config.HOST_STORE,
          benefitReqDtos: items,
          bizValetCardReqDto: virtualApplyCardMsg,
          confirmReqDto: {
            cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
            userId: Stores.AppMod.userInfo.id,
            channel: 2,
            virtualPointId: Util.getLocalCache('virtualPointId'),
            targetVirtualPlanId: Util.getLocalCache('targetVirtualPlanId'),
            bizGiveawayReqDto,
            items: this.filteractivity(newItemResDtos || []),
            ...bvData
          }
        };
        params.dgStatus = 2;
        console.log('get virtualApplyCardMsg', virtualApplyCardMsg, params);
        // if (this.dgMemberInfo) {
        //   // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        //   // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        //   params.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        // }
        if (sourceChannel == 11) {
          params.confirmReqDto.sourceChannel = sourceChannel;
        }
        break;
      }
      default: {
        // 普通下单
        url = 'biz/tradecore/trade/confirm';

        params = {
          cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
          items,
          orderType,
          tradeNo,
          orderProperty,
          dgMemberCode: this.dgMemberInfo ? this.dgMemberInfo.memberCard : '',
          dgMemberName: this.dgMemberInfo ? this.dgMemberInfo.memberName : '',
          bizGiveawayReqDto,
          shopCart: shopCart
        };
        if (multiActivityValidateFlag) {
          params.multiActivityValidateFlag = true;
        }
        if (discount && !isVipRebuy) {
          url = 'biz/tradecore/retail/trade/confirm';
          params.discount = discount;
          params.orderProperty = 1;
        }
        const newParams = this.calParmas({
          val: [
            { key: 'subActivityId', value: 'subActivityId' },
            { key: 'subCardCode', value: 'cardCode' },
            { key: 'subActivityChannel', value: 'subActivityChannel' }
          ],
          params
        });
        params = newParams;
        if (Object.keys(subActivityObj || {}).length > 0) {
          const { subActId, subCardCode } = subActivityObj || {};
          params.subActivityId = subActId;
          params.subCardCode = subCardCode;
        }

        if (isShopMasterMode) {
          url = 'biz/tradecore/retail/trade/confirm';
          params.discount = discount;
          params.orderProperty = orderProperty;
        }
        if (isVipRebuy) {
          params.orderType = 10;
          params.orderProperty = 1;
          delete params.discount;
        }
        if (this.birthday) {
          params.birthday = this.birthday;
        }
        if (getInfo === 'autoComplete') {
          params.teamOrderInitiator = Stores.AppMod.userInfo.id;
        }
        if (this.dgMemberInfo) {
          // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
          // 如果是代客的话，按之前的逻辑，默认为 店铺代客
          params.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        ignoreError = true;

        // 甄选商城订单
        if (isSelectMall) {
          params.orderType = 30;
          // params.orderProperty = '1';
          params.orderProperty = (orderProperty || '').toString();
          params.dgStatus = '0';
          params.bizGiveawayReqDto = {};
          this.isHideCoupon = true;
          // this.orderProperty = '1';
          this.orderProperty = (orderProperty || '').toString();
          this.orderType = 30;
          ignoreError = false;
        }

        // 三生豆订单
        if (this.isBean) {
          url = 'biz/tradecore/bean/trade/confirm';
          params.beanItems = items;
        }

        // 宫主会订单
        if (isPriaItem) {
          url = 'biz/tradecore/priaPoints/trade/confirm';
          params.beanItems = items;
        }
      }
    }
    // 确认订单接口增加主活动id参数 不满足活动中如果包含主活动id则直接抛出异常；
    if (activityId) {
      params.mainActivityId = activityId;
    }
    params.saleMode = globalSaleMode || '';
    params.dreamPlanRelateCard = dreamPlanRelateCard || ''; // 梦想计划cardCode
    console.log('params>>>', params);
    // Toast.loading('请稍候', 100);
    // 0元开卡！！！裂开！！！
    // applyUserInfo 自主注册页面填写过的信息 有值代表 不用再补充资料
    if (localStorage.getItem('noOrderToOpenCard') == 1) {
      if (applyUserInfo) {
        this.orderType = orderType.toString();
        Util.setLocalCache(Config.localStorageKeys.member_applyCardMsg, params.registerCardReqDto);
        this.addOrder('', 1);
        return;
      }
      const pathname =
        +orderType === 7 ? '/store/businessManage/storeAgentMsg' : `/register/memCardMsg`;
      window.app.routerGoTo({
        pathname,
        clear: true,
        // state: { applyType: orderType, agentId, healthy, phone },
        state: {
          applyType: orderType,
          globalSaleMode: globalSaleMode || '',
          dreamPlanRelateCard: dreamPlanRelateCard || ''
        }
      });
      return;
    }

    // 致道开卡和升级场景，购买特定的产品需要用特性的地址, 获取特定产品的code
    this.getSpecialProductCodeList(orderType);

    if (this.isCarnival) {
      ignoreError = !this.isCarnival;
    }

    try {
      // 将请求存储在mobx
      this.confirmParams = {
        url,
        params
      };
      let { data, resultCode, resultMsg, extFields } = yield Serv.confirmOrder(
        url,
        params,
        ignoreError
      );
      // 存储返回的值 用于获取附属赠品的接口传参
      this.confirmReturnData = data;
      // Toast.hide();
      if (+getInfo === getInfoSign) {
        return data;
      }

      if (resultCode != '0') {
        // 开卡/升级/开店无需弹这个继续提交的弹窗
        let codeArr = Object.keys(activityTipTitleMap);
        if (+resultCode === 8458) {
          this.tagStatus = 1;
          this.handleActivityCommonTip(activityTipTitleMap[resultCode], resultMsg);
        } else if (+resultCode === 8862) {
          this.notSatisfiedModal({
            extFields,
            productDetailMod,
            checkParams,
            getInfo,
            sign,
            objectValue,
            ignoreError,
            ment,
            activityLink,
            addActivityId,
            suport1to2
          });
        } else if (+resultCode === 10353) {
          window.showConfirmModal({
            title: '温馨提示',
            content: resultMsg || '您的会员未激活, 请先去激活, 即可活动参与活动的资格',
            rightTxt: '前往激活套餐',
            hideLeftText: true,
            isClickNull: true,
            onConfirmPress: () => {
              window.app.routerGoTo({
                pathname: `/shop/home/special/1282600105317547116`,
                state: {
                  inletTitle: `资格购-去激活`,
                  globalSaleMode: globalSaleMode || '',
                  dreamPlanRelateCard: dreamPlanRelateCard || ''
                }
              });
            }
          });
        } else if (+resultCode === 8953) {
          window.showConfirmModal({
            title: '温馨提示',
            content: resultMsg || '您的手机号还不存在二星销售经理的账号，请前去二星专区下单',
            rightTxt: '去二星专区',
            onConfirmPress: async () => {
              const shopHomeMod = Stores.ShopHomeMod || {};
              shopHomeMod.doLinkJump({
                type: 10,
                content: '{"route":"OpenCard","id":"1357051942432554018"}'
              });
            }
          });
        } else {
          // * orderType '1'零售订单 '2'复消订单 '3'自主开卡 '4'会员自主升级/会员代客升级 '5'会员新客注册 '6'申请开店 '7'店铺新客注 册 '8'店铺老客升级。 '9': 维多益站点会员代客升级
          if (codeArr.indexOf(resultCode) !== -1 && ![3, 4, 5, 6, 7, 8].includes(+orderType)) {
            // 超过活动库存，弹窗提示
            if (resultCode == '8858') {
              this.handleActivityOutStock(
                activityTipTitleMap[resultCode],
                resultMsg,
                () => {
                  if (data && data.correctReq && data.correctReq.items) {
                    let params = {
                      items: data.correctReq.items,
                      orderType,
                      orderProperty,
                      bizGiveawayReqDto,
                      saleMode: globalSaleMode || '',
                      dreamPlanRelateCard: dreamPlanRelateCard || ''
                    };
                    if (discount) {
                      params.discount = discount;
                      params.orderProperty = 1;
                    }
                    if (isShopMasterMode) {
                      params.orderProperty = orderProperty;
                    }
                    if (isVipRebuy) {
                      params.orderType = 10;
                    }

                    this.confirmOrder(
                      params,
                      null,
                      null,
                      null,
                      null,
                      ment,
                      activityLink,
                      addActivityId
                    );
                  }
                },
                activityType
              );
            } else {
              this.handleActivityCommonTip(activityTipTitleMap[resultCode], resultMsg);
            }
          } else {
            // Toast.fail(resultMsg, 3, null, !toastThrough);
            // if (sign === 'storeBuy') {
            //   this.handleActivityCommonTip(activityTipTitleMap[resultCode], resultMsg);
            // } else {
            if (resultCode == '8863') {
              window.showConfirmModal({
                content: resultMsg,
                leftTxt: '继续结算',
                rightTxt: '返回调整',
                onCancelPress: () => {
                  this.confirmOrder(
                    {
                      ...checkParams,
                      orderProperty: +checkParams.orderProperty - 1,
                      globalSaleMode: globalSaleMode || '',
                      dreamPlanRelateCard: dreamPlanRelateCard || ''
                    },
                    getInfo,
                    sign,
                    objectValue,
                    ignoreError,
                    ment,
                    activityLink,
                    addActivityId
                  );
                }
              });
            } else {
              this.visible = true;
              this.renderPopup(resultMsg, sign);
            }
            // }
          }
        }

        // Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, '');
        return false;
      }
      if (suport1to2) {
        this.notSatisfiedModal({
          extFields,
          productDetailMod,
          checkParams,
          getInfo,
          sign,
          objectValue,
          ignoreError,
          ment,
          activityLink,
          addActivityId,
          suport1to2
        });
        return false;
      }
      this.tagStatus = 0;

      // 正常返回
      this.giveawayInfoList = data.giveawayInfoList || [];
      data.subActivityId ? (this.subActivityId = data.subActivityId) : (this.subActivityId = '');
      data.subCardCode ? (this.subCardCode = data.subCardCode) : (this.subCardCode = '');
      Util.setLocalCache(Config.localStorageKeys.shop_confirmItems, JSON.stringify(items));
      Util.setLocalCache(Config.localStorageKeys.shop_orderType, orderType);
      Util.setLocalCache(Config.localStorageKeys.shop_orderProperty, orderProperty);
      Util.setLocalCache(Config.localStorageKeys.shop_orderDiscount, discount);
      Util.setLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto, bizGiveawayReqDto);
      Util.setLocalCache(Config.localStorageKeys.shop_couponAutoSelect, coupon.id ? coupon : {});
      // 开卡、升级下单慢接口优化 接口加传参confirmReqId
      Util.setLocalCache(Config.localStorageKeys.confirm_req_id, data.confirmReqId || '');

      this.orderType = orderType;
      this.orderProperty = orderProperty;
      this.discount = discount;

      // 请求运费券
      let ids = (data.activityDiscountInfo || []).map((item) => item.activityId);
      this.getFreightCouponList(ids.join(','), { items: data.items });

      this.isShoppingPatterns = false;
      console.log(3333);
      // 资格购是否可用优惠券
      (data.activityDiscountInfo || []).map((item) => {
        if (item.activityType == '6' && item.shoppingPatterns == '1') {
          this.isShoppingPatterns = true;
        }
        if (item.superimposCoupon == 0) {
          this.qualifyCoupon = true;
        }
      });

      delete data.freightAmount;
      Object.assign(this.orderInfo, data);

      if (
        Stores.AppMod.userInfo.belongSystem == 'CSS' &&
        [5, 3, 4, 7, 8].includes(+this.orderType)
      ) {
        // 茶色素清除店铺
        this.defaultBelongShop = '';
        this.belongShop = '';
      } else {
        this.defaultBelongShop = data.shopCode;
        this.belongShop = data.shopCode;
      }
      this.shopName = data.realName || '';
      // this.bvDiyNum = bvData.bv;
      // this.bvMode = bvData.bvMode;
      this.availableBelongShop = true;
      this.itemList = data.items;
      console.log('data=====>', data.items);
      let productCodeList = [];
      data.items.map((item) => {
        productCodeList.push(item.code);
      });
      if (
        productCodeList.includes('WD751') ||
        productCodeList.includes('WD752') ||
        productCodeList.includes('WD753')
      ) {
        this.isSpecial = true;
      }
      this.needForm = data.form;
      this.birthday = data.birthday;
      if (data.formType == 'stemCells') {
        this.isCellMode = true;
        let list = Array(...{ length: data.writeNum });
        list.forEach((item) => {
          this.cellsForm.push(
            observable({
              name: '',
              identityCard: '',
              formType: data.formType
            })
          );
        });
      }

      if (!Array.of(3, 4, 5, 6, 7, 8).includes(+this.orderType)) {
        Toast.loading('请稍候', 0);
        yield this.getDeliverys();
        yield this.getLogistics();
        Toast.hide();
      }
      const thisList = [3, 5, 7];
      const upgrate = [4, 8];
      // applyUserInfo 自主注册页面填写过的信息 有值代表 不用再补充资料
      if (thisList.includes(+orderType) && $supplementInfo && (!applyUserInfo || orderType != 3)) {
        const pathname =
          +orderType === 7 ? '/store/businessManage/storeAgentMsg' : `/register/memCardMsg`;
        // if (+orderType === 5 && Stores.AppMod.userInfo.belongSystem == 'KER') {
        //   // 可儿玫瑰 跳转至升级补充资料
        //   const {memberCard} = this.dgMemberInfo || {};
        //   const localCardCode = memberCard || Stores.AppMod.userInfo.cardCode;
        //   window.app.routerGoTo({
        //     pathname: '/personal/msgAdd',
        //     clear: true,
        //     state: {
        //       applyType: orderType,
        //       data: {
        //         localCardCode,
        //       },
        //     },
        //   });
        //   return;
        // }
        localStorage.setItem('saveInfo', 1);
        window.app.routerGoTo({
          pathname,
          clear: true,
          // state: { applyType: orderType, agentId, healthy, phone },
          state: {
            data: {
              dgUserId: this.dgUserId
            },
            applyType: orderType,
            globalSaleMode: globalSaleMode || '',
            dreamPlanRelateCard: dreamPlanRelateCard || ''
          }
        });
      } else {
        if (upgrate.includes(+orderType) && $supplementInfo) {
          const { memberCard, cardType } = this.dgMemberInfo || {};
          console.log('🚀 ~ this.dgMemberInfo:', this.dgMemberInfo);
          const mode = true;
          const localCardCode = memberCard || Stores.AppMod.userInfo.cardCode;
          Stores.RegisterStoreMod.checkMsgIsFull(localCardCode, mode, $cardTypeId).then((res_2) => {
            // 资料不全，跳转填写
            if (res_2) {
              localStorage.setItem('saveInfo', 1);
              const pathname = '/personal/msgAdd';
              window.app.routerGoTo({
                pathname,
                clear: true,
                state: {
                  applyType: orderType,
                  data: {
                    localCardCode,
                    isDG
                  },
                  globalSaleMode: globalSaleMode || '',
                  dreamPlanRelateCard: dreamPlanRelateCard || ''
                }
              });
            } else {
              if (window.app.router.location.pathname.indexOf('/checkOrder') == -1) {
                window.app.routerGoTo({
                  pathname: `/shop/checkOrder`,
                  state: {
                    ment,
                    activityLink,
                    addActivityId,
                    applyUserInfo,
                    inletTitle,
                    sourceTag,
                    goodsCouponTag,
                    sourceNo,
                    sourceChannel,
                    globalSaleMode: globalSaleMode || '',
                    dreamPlanRelateCard: dreamPlanRelateCard || '',
                    shopCart,
                    isMb,
                    isPriaItem,
                    voucherInfo,
                    isXkcActivity,
                    invitationUserId
                  }
                });
              }
            }
          });
        } else {
          this.checkOrderData = {
            ment,
            activityLink,
            addActivityId,
            applyUserInfo,
            inletTitle,
            sourceTag,
            goodsCouponTag,
            sourceNo,
            sourceChannel,
            globalSaleMode: globalSaleMode || '',
            dreamPlanRelateCard: dreamPlanRelateCard || '',
            freeShippingNo: freeShippingNo || '',
            shopCart,
            isMb,
            isPriaItem,
            voucherInfo,
            isXkcActivity,
            invitationUserId
          };
          // 需要完善申请资料(店铺信息)
          if (applyMaterial == 1) {
            window.app.routerGoTo({
              pathname: '/register/storeLicense',
              state: {
                needCertificationLists: needCertificationList,
                checkName: checkName,
                hasCheckOrder: true // 有订单&需要完善资料
              }
            });
          } else {
            if (window.app.router.location.pathname.indexOf('/checkOrder') == -1) {
              window.app.routerGoTo({
                pathname: `/shop/checkOrder`,
                state: this.checkOrderData
              });
            }
          }
        }
      }

      let activityIdList = [];
      if (data && data.activityDiscountInfo && data.activityDiscountInfo.length > 0) {
        activityIdList = data.activityDiscountInfo.map((item) => item.activityId);
      }
      // 如果是秒杀订单，就不请求顺手买一单
      if (
        data &&
        data.activityDiscountInfo &&
        (data.activityDiscountInfo || []).some((item) => item.activityType == 5)
      )
        return true;
      // 顺手买一单
      // 记录顺手买一单入参，后续使用
      this.easeBuyParams = {
        orderType: orderType,
        activityIdList,
        globalSaleMode: globalSaleMode || '',
        dreamPlanRelateCard: dreamPlanRelateCard || ''
      };

      this.getEaseBuyItemList(data.orderType, activityIdList, globalSaleMode, {
        dreamPlanRelateCard
      });
      return true;
    } catch (e) {
      // Toast.hide();
      console.log('e>>>>>>', e);
      Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, '');
    }
    return false;
  });

  getAddressInfo = flow(function* () {
    if (this.orderType != 6) {
      Toast.loading('请稍候', 0);
      yield this.getDeliverys();
      yield this.getLogistics();
      Toast.hide();
    }
  });

  /**
   * 整合预售信息
   *
   */
  prepareAdvanceInfo = () => {
    const {
      countDownForDepositEnd,
      countDownForDepositStart,
      countDownForTailEnd,
      countDownForTailStart,
      preSellType
    } = this.activityInfo;

    if (preSellType === advanceSaleTypeMap.DEPOSITSALE) {
      if (countDownForDepositStart > 0 && countDownForDepositEnd > 0) {
        // 支付定金开始和结束时间都大于0，说明活动尚未开始
        this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYUNSTART;
      } else if (countDownForDepositStart < 0 && countDownForDepositEnd > 0) {
        // 支付定金阶段

        this.advanceSaleStatus = advanceSaleStatusMap.PAYFORDEPOSIT;
      } else if (
        countDownForDepositStart < 0 &&
        countDownForDepositEnd < 0 &&
        countDownForTailStart > 0 &&
        countDownForTailEnd > 0
      ) {
        // 待付尾款阶段

        this.advanceSaleStatus = advanceSaleStatusMap.WAITFORTAIL;
      } else if (
        countDownForDepositStart < 0 &&
        countDownForDepositEnd < 0 &&
        countDownForTailStart < 0 &&
        countDownForTailEnd > 0
      ) {
        // 支付尾款

        this.advanceSaleStatus = advanceSaleStatusMap.PAYFORTAIL;
      } else if (
        countDownForDepositStart < 0 &&
        countDownForDepositEnd < 0 &&
        countDownForTailStart < 0 &&
        countDownForTailEnd < 0
      ) {
        // 活动结束

        this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYEND;
      }
    } else if (preSellType === advanceSaleTypeMap.FULLPAYMENT) {
      this.advanceSaleStatus = advanceSaleStatusMap.GOBUY;
    }
    console.log(this.advanceSaleStatus, 7777);
  };

  /**
   * 初始化，获取核对订单信息等（核对订单、获取配送方式页面刷新时调用）
   */
  init = flow(function* ({ globalSaleMode = '', dreamPlanRelateCard = '' }) {
    // 获取享包邮产品
    let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
    const orderType = Util.getLocalCache(Config.localStorageKeys.shop_orderType);
    const orderProperty = Util.getLocalCache(Config.localStorageKeys.shop_orderProperty);
    const discount = Util.getLocalCache(Config.localStorageKeys.shop_orderDiscount);
    // 满赠活动的
    let bizGiveawayReqDto = Util.getLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto);
    let coupon = Util.getLocalCache(Config.localStorageKeys.shop_couponAutoSelect);
    this.validStoreCollection();

    if (!this.itemList || this.itemList.length == 0) {
      // 还没核对过订单信息
      try {
        confirmItems = JSON.parse(confirmItems) || [];
        bizGiveawayReqDto = bizGiveawayReqDto || {};
      } catch (e) {
        window.app.routerRedirect('/');
      }
      yield this.confirmOrder({
        items: confirmItems,
        orderType,
        orderProperty,
        discount,
        bizGiveawayReqDto,
        coupon,
        globalSaleMode: globalSaleMode || '',
        dreamPlanRelateCard: dreamPlanRelateCard || '',
        freeShippingNo: this.freeShippingNo || '',
        isPriaItem: this.isPriaItem || false
      });
    }

    console.log(
      "Util.getLocalCache('virtualNeedOrder')>>>",
      this.hasRequest,
      Util.getLocalCache('virtualNeedOrder')
    );

    if (!this.hasRequest) {
      this.hasRequest = true;

      // 非开店订单，收货方式和收货地址从后台获取
      // if (orderType != 6) {
      //   yield this.getDeliverys();
      //   yield this.getLogistics();
      // } else {
      if (orderType == 6) {
        const { deliveryType, cloudWarehouse } = yield this.getStorePolicyConfig();
        // 开店订单的收货方式，则默认只能店铺代收，店铺代收地址取本地缓存，无需从后台获取
        const { registerCardReqDto, shopContactInfoDto } =
          Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg) || {};
        const { deliveryAddress } = shopContactInfoDto || {};
        this.deliveryAddress = {
          deliveryName: registerCardReqDto.realName,
          deliveryMobile: shopContactInfoDto.cellphone,
          cityCode: deliveryAddress.cityCode,
          mobileAreaCode: deliveryAddress.mobileAreaCode || '',
          detailed:
            deliveryAddress.provinceName +
            deliveryAddress.cityName +
            deliveryAddress.countyName +
            deliveryAddress.streetName +
            (deliveryAddress.communityName || '') +
            deliveryAddress.detailAddress
        };
        // 是否开启云仓
        if (cloudWarehouse) {
          this.deliveryList = [
            {
              name: '工作室地址',
              type: 3
            },
            {
              name: '云仓',
              type: 5
            }
          ];
        } else {
          this.deliveryList = [this.deliveryAddress];
        }
        this.storeInfo = this.deliveryAddress;
        this.deliveryType = 3;
        // 虚拟资格 无需显示 优惠券、运费券
        Util.getLocalCache('virtualNeedOrder') !== 1 && this.getCouponList();
      }
    }
  });

  /**
   * 获取商品编码列表
   */
  @computed
  get getItemCodeList() {
    try {
      const { items } = this.confirmReturnData || {};
      const itemCodeList =
        Array.isArray(toJS(items)) &&
        items.length > 0 &&
        items.map((res) => {
          const { code } = res || {};
          return code;
        });
      return itemCodeList;
    } catch (error) {
      console.log(error, '获取商品编码失败');
      return [];
    }
  }

  /**
   * 获取享包邮产品参数
   */
  // #region 获取享包邮产品参数
  @computed
  get orderKeyParams() {
    try {
      //deliveryType 1：个人收货，2：自提，3：店铺代收
      // 只有选择了配送方式后才返回地址信息
      let orderType = this.orderType;
      if (orderType == 5 || orderType == 7) {
        orderType = 3;
      } else if (orderType == 8) {
        orderType = 4;
      }
      if (!this.deliveryType) {
        return {
          orderType,
          provinceCode: '',
          cardTypeId: this.cardTypeId || '',
          itemCodes: this.getItemCodeList || []
        };
      }
      const deliveryAdd =
        this.deliveryType == 1
          ? this.deliveryAddress
          : this.deliveryType == 3
            ? this.storeInfo
            : this.pickUpInfo;
      const { provinceCode = '' } = deliveryAdd || {};
      return {
        orderType,
        provinceCode: provinceCode || '',
        cardTypeId: this.cardTypeId || '',
        itemCodes: this.getItemCodeList || []
      };
    } catch (error) {
      return {};
    }
  }

  /**
   * 获取享包邮产品,用于判断是否是要默认选中享包邮礼包
   * 1. 如果有返回数据 默认选中中享包邮礼包
   * 2. 享包邮产品展示接口返回的数据
   */
  // #region 获取享包邮产品
  @action
  getFreeShippingOrderItems = flow(function* () {
    const obj = this.orderKeyParams;
    try {
      const { data, extFields } = yield Serv.getFreeShippingOrderItems(obj);
      if (data) {
        this.freeShippingItem = data || [];
        const { freeShippingConfigCode = '' } = extFields || {};
        this.freeShippingConfigCode = freeShippingConfigCode || '';
        this.freeShippingItem &&
          this.freeShippingItem.length > 0 &&
          this.changeState({
            internationalFreightType: 2
          });
      } else {
        this.freeShippingConfigCode = '';
        this.freeShippingItem = [];
      }
    } catch (error) {
      this.freeShippingItem = [];
      this.freeShippingConfigCode = '';
      console.log(error, '获取享包邮产品失败');
    }
  });

  @computed
  get addPrice() {
    try {
      if (this.internationalFreightType != internationalFreightTypeMap.FREE_SHIPPING) return 0;
      const v = (this.freeShippingItem || []).reduce((pre, cur) => pre + (cur.price || 0), 0) || 0;
      console.log(v, '享包邮产品价格');
      return v;
    } catch (error) {
      return 0;
    }
  }

  /**
   * 获取配送方式
   * 对象不适用、禁用：隐藏，
   * 订单金额不在范围内：置灰
   * 状态为启用，对象适用，订单金额在范围内：可选择该收货方式
   */
  @action
  getDeliverys = flow(function* () {
    try {
      // 如果是代客开卡、代客升级，则根据客户的userType来取地址列表，其他情况根据自身的userType来取地址列表；
      // const userType = [5, 7].includes(+this.orderType) ? 1 : this.orderType == 8 ? 2 : Stores.AppMod.userType;
      let cloudUserId = localStorage.getItem('cloudUserId'); // 1352709397881747463
      const { userType } = Stores.AppMod;
      const { cloudStorageTag, giftStorageTag, id } = Stores.AppMod.userInfo;
      console.log('getDeliverys22', this.orderType);
      // dgStatus 0-自购(默认，可不传)，1-店铺代客，2-会员代客
      console.log(
        'this.dgMemberInfo',
        cloudUserId,
        giftStorageTag,
        this.orderType,
        toJS(this.dgMemberInfo)
      );
      if (
        giftStorageTag == 1 &&
        [1, 2].includes(+this.orderType) &&
        !this.dgMemberInfo &&
        Util.getLocalCache('virtualNeedOrder') !== 1
      ) {
        // 礼品仓,非代客情况下
        cloudUserId = id;
      }
      let dgMemberCode = this.dgMemberInfo ? this.dgMemberInfo.memberCard : '';
      this.isDgUserid = !!(cloudUserId || dgMemberCode);
      console.log('asdasdasd222', cloudUserId);
      const {
        totalAmount = 0,
        freightAmount = 0,
        freightCouponAmount = 0,
        easeBuyFreight = 0
      } = this.orderInfo;

      const { data: configList } = yield Serv.queryCloudStorageOrderConfig({
        orderType: this.orderType,
        orderAmount: totalAmount - freightAmount - (freightCouponAmount || 0) + easeBuyFreight,
        orderProperty: this.orderProperty,
        type: 'delivery'
      });
      console.log('configDataconfigDataconfigData', configList);

      let { data } = yield Serv.getDeliverys(
        cloudUserId
          ? {
              dgUserId: cloudUserId
            }
          : {}
      );
      let list = [];
      if (data && data.length > 0) {
        const giftConfig = (configList || []).find((val) => val.type === '7') || {};
        const newConfig = (configList || []).find((val) => val.type === '8') || {};
        console.log('sssxx', giftConfig, newConfig);
        if (!giftConfig.value && !newConfig.value) {
          data = data.filter((val) => !['7', '8'].includes(val.type));
        } else {
          const { giftWarehouseConfig = {}, newWarehouseConfig = {} } =
            yield Stores.AppMod.getGiftWarehouseConfig();
          this.giftWarehouseConfig = giftWarehouseConfig;
          this.newWarehouseConfig = newWarehouseConfig;
          if (giftConfig.value) {
            data.map((val) => {
              if (val.type === '7') {
                val.name = this.giftWarehouseConfig.basic && this.giftWarehouseConfig.basic.name;
              }
            });
          } else {
            data = data.filter((val) => val.type !== '7');
          }
          if (newConfig.value) {
            data.map((val) => {
              if (val.type === '8') {
                val.name = this.newWarehouseConfig.basic && this.newWarehouseConfig.basic.name;
              }
            });
          } else {
            data = data.filter((val) => val.type !== '8');
          }
        }
        console.log('datadatadatadata123123', data);

        // data = data.filter((val) => !['7', '8'].includes(val.type));
        for (let item of data) {
          let { payAmountBegin, payAmountEnd, usePerson = [], type } = item;
          if (!usePerson) {
            usePerson = [];
          }
          // if(cloudStorageTag==1 && type=='5'){
          //   list.push(item)
          // }
          if (type == 3 && this.orderType == 6) {
            usePerson.push('1');
          }
          // // 个人礼品仓别名
          // if (type == 7) {
          //   item.name = this.giftWarehouseConfig.basic && this.giftWarehouseConfig.basic.name;
          // }
          // if (type == 8) {
          //   item.name = this.newWarehouseConfig.basic && this.newWarehouseConfig.basic.name;
          // }
          // 店铺拥有的收货方式，子账号也拥有
          if (usePerson.includes('3')) {
            usePerson.push('5');
          }
          if (usePerson.indexOf(`${userType}`) >= 0) {
            if (
              (payAmountBegin != null && totalAmount < payAmountBegin) ||
              (payAmountEnd != null && totalAmount > payAmountEnd)
            ) {
              item.disabled = true;
              if (this.deliveryType == type) {
                this.setDeliveryType('');
              }
            }
            list.push(item);
          }
        }
      }
      console.log('list>>>>', list);

      // 致道特殊产品升级开卡购买时只能选个人收货方式
      const hasSpecialProduct = this.getHasSpecialProduct();
      if (hasSpecialProduct) {
        list = list.filter((item) => item.type === '1');
      }

      this.deliveryList = list;
    } catch (e) {
      console.log('getDeliverys err', e);
    }
  });

  /**
   * 设置默认选择运费券
   */
  selectDefaultFreightCoupon = async () => {
    // 外部带券下单时，不自动勾选运费券
    if (this.isHideCoupon) return;

    const { usableList = [] } = this.freightCouponInfo;
    if (usableList.length === 0) return;

    // 销售专区不默认勾选运费券
    if (this.globalSaleMode == 2) return;

    const { freightAmount = 0 } = this.orderInfo;
    const userInfo = Stores.AppMod.userInfo || {};
    // 自主下单且收货方式为自提和个人收货时收货人手机号和操作人是一样的才默认选中;
    if (!this.isMemberDg && (this.deliveryType == 1 || this.deliveryType == 2)) {
      const userPhone = await Stores.AppMod.getDecyptMsg({
        id: userInfo.id,
        scene: 206,
        channel: ''
      });

      let deliveryPhone =
        this.deliveryType == 1
          ? this.deliveryAddress && this.deliveryAddress.deliveryMobile
          : this.pickUpInfo && this.pickUpInfo.deliveryMobile;

      if (deliveryPhone && deliveryPhone.indexOf('*') != -1) {
        deliveryPhone = await Stores.AppMod.getDecyptMsg({
          id:
            this.deliveryType == 1
              ? this.deliveryAddress && this.deliveryAddress.userAddressId
              : userInfo.id,
          scene: this.deliveryType == 1 ? 207 : 206,
          channel: ''
        });
      }
      if (userPhone == deliveryPhone && freightAmount) {
        this.setDefaultFreightCoupon(0);
      }
    }
  };

  /**
   * 选中默认优惠券
   *
   * @memberof CheckOrderMod
   */
  selectDefaultCoupon = async () => {
    const usableList = this.couponInfo.usableList || [];
    const fisrtCoupon = usableList[0] || {};
    const mustUseNumber = this.couponInfo.mustUseNumber || 0;

    // 销售专区不默认勾选优惠券
    if (this.globalSaleMode == 2) return;

    // 必选数量大于0 第一张的券的券类型时抵扣券并且允许叠加并且无门槛
    const selectedCoupons = [],
      deduction = [];
    if (
      mustUseNumber > 0 &&
      fisrtCoupon.couponType === CouponTypeMap.DEDUCTION &&
      fisrtCoupon.useSuperimposedType === 1 &&
      fisrtCoupon.thresholdAmount === 0
    ) {
      usableList.forEach((coupon, index) => {
        if (
          selectedCoupons.length < mustUseNumber &&
          coupon.couponType === CouponTypeMap.DEDUCTION &&
          coupon.useSuperimposedType === 1 &&
          coupon.thresholdAmount === 0
        ) {
          deduction.push(coupon);
          selectedCoupons.push(index);
        }
      });
      this.changeState({
        deduction: selectedCoupons,
        selectedCoupons: selectedCoupons
      });
      this.getFreight();
      return;
    }
    // 有外部带入的优惠券，选中外部的优惠券，没有的取最优的优惠券(可用列表的第一个，后端已经排序好了)默认选中
    let chooseCouponId = localStorage.getItem('h_couponTemplateId');
    const userInfo = Stores.AppMod.userInfo || {};
    // 自主下单且收货方式为自提和个人收货时收货人手机号和操作人是一样的才默认选中
    if (!this.isMemberDg && !chooseCouponId && (this.deliveryType == 1 || this.deliveryType == 2)) {
      const userPhone = await Stores.AppMod.getDecyptMsg({
        id: userInfo.id,
        scene: 206,
        channel: ''
      });

      let deliveryPhone =
        this.deliveryType == 1
          ? this.deliveryAddress && this.deliveryAddress.deliveryMobile
          : this.pickUpInfo && this.pickUpInfo.deliveryMobile;

      if (deliveryPhone && deliveryPhone.indexOf('*') != -1) {
        deliveryPhone = await Stores.AppMod.getDecyptMsg({
          id:
            this.deliveryType == 1
              ? this.deliveryAddress && this.deliveryAddress.userAddressId
              : userInfo.id,
          scene: this.deliveryType == 1 ? 207 : 206,
          channel: ''
        });
      }

      if (userPhone == deliveryPhone) {
        chooseCouponId = usableList[0] && usableList[0].id;
      }
    }
    if (chooseCouponId) {
      let ind =
        Array.isArray(toJS(usableList)) &&
        toJS(usableList).findIndex((v) => v.id == chooseCouponId);
      if (typeof ind !== 'number' || ind === -1) {
        return;
      }
      if (usableList[ind].couponType == 1) {
        this.changeState({ deduction: [usableList[ind]] });
      }
      this.changeState({ selectedCoupons: [ind] });
      this.getFreight();
    }
  };

  /**
   * 获取下单可用优惠券
   */
  getCouponList = flow(function* () {
    // 普通下单，已选地址，则获取优惠券
    // console.log('普通下单，已选地址，则获取优惠券', this.orderType, this.deliveryAddress, this.couponInfo.addressId, this.isHideCoupon);
    // applyType 自主注册-3 会员代客注册-5 店铺代客注册-7 自主升级-4 会员代客升级-9 店铺代客升级-8
    // 享包邮单子，不获取优惠券
    if (
      ![1, 2, 4, 5, 7, 8].includes(+this.orderType) ||
      this.isHideCoupon ||
      this.freeShippingNo ||
      this.isPriaItem
    ) {
      // 去除个人地址相关判断，东哥要求跟APP保持一致
      // !this.deliveryAddress ||
      // this.couponInfo.addressId == this.deliveryAddress.userAddressId ||
      return;
    }

    const confirmItems = JSON.parse(
      Util.getLocalCache(Config.localStorageKeys.shop_confirmItems) || '[]'
    );
    let orderType = this.orderType;
    // 开卡类型: '7' - 店铺新客注册，'8' - 店铺老客升级
    if (orderType == 5 || orderType == 7) {
      orderType = 3;
    } else if (orderType == 8) {
      orderType = 4;
    }
    const params = {
      dgUserId: this.dgMemberInfo || [5, 7, 8].includes(+this.orderType) ? this.dgUserId : '',
      dgMemberCode: this.dgMemberInfo ? this.dgMemberInfo.memberCard : '',
      dgMemberName: this.dgMemberInfo ? this.dgMemberInfo.memberName : '',
      items: confirmItems,
      orderType: orderType,
      orderProperty: this.orderProperty,
      discount: this.discount,
      cardTypeId: this.cardTypeId,
      bizGiveawayReqDto: Util.getLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto) || {}
    };
    // 开方单子
    if (this.sourceNo) {
      params.learnOrderTag = 2;
    }
    const { data } = yield Serv.getCouponList(params);
    const { usableCount, usableList, unUsableCount, unUsableList, mustUseNumber } = data;
    this.couponInfo = {
      addressId: (this.deliveryAddress && this.deliveryAddress.userAddressId) || '',
      usableCount,
      usableList,
      unUsableCount,
      unUsableList,
      mustUseNumber
    };
    this.selectDefaultCoupon();
  });

  /**
   * 获取特殊订单的BV
   */
  queryCouponCreateBv = flow(function* () {
    console.log('特殊订单');
    const shareId = localStorage.getItem('shareIdVistor') || undefined;
    const orderParams = this.getOrderParams('');
    if (orderParams.deliveryAddress.deliveryType == 2) {
      // 解密手机号
      if (orderParams.deliveryAddress.deliveryMobile.indexOf('*') != -1) {
        orderParams.deliveryAddress.deliveryMobile = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 206,
          channel: ''
        });
      }
      // 解密姓名
      if (
        orderParams.deliveryAddress.deliveryName &&
        orderParams.deliveryAddress.deliveryName.indexOf('*') != -1
      ) {
        orderParams.deliveryAddress.deliveryName = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 101,
          channel: ''
        });
      }
    }
    if (this.dgMemberInfo) {
      // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
      // 如果是代客的话，按之前的逻辑，默认为 店铺代客
      orderParams.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
    }
    try {
      const { data } = yield Serv.queryCouponCreateBv({
        shareSource: 1,
        shareId,
        cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
        ...orderParams,
        deliveryType: this.deliveryType,
        couponList: this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id),
        freightCouponList:
          this.selectedFreightCoupon >= 0
            ? [this.freightCouponInfo.usableList[this.selectedFreightCoupon].id]
            : []
      });
      console.log('data===>', data);
      this.isSpecialBv = data;
    } catch (err) {}
  });

  /**
   * 获取下单可用运费券
   */
  getFreightCouponList = flow(function* (ids, { items = {} }) {
    // 非普通下单（即开卡升级开店订单），不请求运费券
    // 享包邮单子不请求运费劵
    if (this.isHideCoupon) {
      this.freightCouponInfo = cloneDeep(couponInfo);
      this.selectedFreightCoupon = -1;
      this.tmpFreightIdx = -1;
      return;
    }
    if (![1, 2].includes(+this.orderType) || this.freeShippingNo) return;
    const itemIds = items.map((item) => item.itemSerial);
    const params = {
      itemIdList: itemIds,
      activityIds: ids,
      orderType: this.orderType,
      allocateCargoScale: this.orderProperty,
      freightAmount: this.orderInfo.freightAmount,
      dgUserId: this.dgUserId || '', // 会员A代客B下单，B的userId
      saleMode: this.globalSaleMode || ''
    };
    if (this.discount) {
      params.discount = this.discount;
    }
    const { data } = yield Serv.getFreightCouponList(params);
    const { usableCount, usableList, unUsableCount, unUsableList } = data;
    this.freightCouponInfo = {
      addressId: '',
      usableCount,
      usableList,
      unUsableCount,
      unUsableList
    };
  });

  /**
   * 设置外部带入的默认地址
   *
   * @memberof ConfirmOrderMobx
   */
  setDefaultAddress = (deliveryAddressMap = {}) => {
    if (
      (this.isMemberDg && !this.freeShippingNo) ||
      !this.defaultAddressInfo.id ||
      !deliveryAddressMap[1]
    )
      return;
    if (getIsUnsubscribeOrSleep()) {
      return;
    }
    const {
      id,
      detailAddr,
      districtCode,
      district,
      cityCode,
      city,
      phone,
      contact,
      provinceCode,
      province,
      streetCode,
      street = '',
      communityName = '',
      communityCode = '',
      isInternational,
      address
    } = this.defaultAddressInfo;
    deliveryAddressMap[1] = {
      userAddressId: id,
      address: address || detailAddr,
      areaCode: districtCode,
      areaName: district,
      cityCode,
      cityName: city,
      defaultAddress: true,
      deliveryAddressMap: null,
      deliveryMobile: phone,
      deliveryName: contact,
      deliveryType: '1',
      detailed:
        (province || '') +
        (city || '') +
        (district || '') +
        (street || '') +
        (communityName || '') +
        (detailAddr || ''),
      extFields: {},
      geoX: null,
      geoY: null,
      id: null,
      mobileAreaCode: null,
      provinceCode,
      provinceName: province,
      shopCode: null,
      streetCode,
      streetName: street,
      communityName,
      communityCode,
      userAddressList: null,
      isInternational
    };
  };

  /**
   * 获取顾客默认收货方式及收货地址
   */
  getLogistics = flow(function* () {
    if (this.deliveryAddress && this.deliveryType) {
      return;
    }
    try {
      let params = {};
      // 代客情况下传客的信息
      console.log('hgfhjasdkshd', this.dgCardCode, this.dgUserId);
      if ([5, 7, 8, 10].includes(+this.orderType) || this.dgMemberInfo) {
        if (this.dgCardCode && this.dgUserId) {
          params.memberCard = this.dgCardCode;
        } else if (this.dgUserId) {
          params.userId = this.dgUserId;
        }
      }
      // 会员代客升级
      const localMemInfo = Util.getLocalCache('store_agentUpgradeMember') || {};
      const memberForUpdate = Util.getLocalCache('memberForUpdate');
      if (memberForUpdate) {
        params.memberCard = localMemInfo.cardCode;
      }
      // 致道特殊产品升级开卡购买时只能选个人收货方式
      const hasSpecialProduct = this.getHasSpecialProduct();

      const { data } = hasSpecialProduct
        ? yield Serv.getSpecialLogistics()
        : yield Serv.getLogistics(params);
      if (data) {
        const { deliveryAddressMap } = data;
        this.setDefaultAddress(deliveryAddressMap);
        let promiseList = [];
        if (deliveryAddressMap) {
          Object.keys(deliveryAddressMap).forEach((key) => {
            // 1个人 2自提 3店铺
            const item = deliveryAddressMap[key];
            switch (+key) {
              case 1: {
                let case1 = async () => {
                  console.log('itemitemitemitemitem', item);
                  if (!this.deliveryAddress && item && item.deliveryName) {
                    let decyptAddress = item.address;
                    // 判断地址是否有带星
                    if (item.address.indexOf('*') != -1) {
                      decyptAddress = await Stores.AppMod.getDecyptMsg({
                        id: item.userAddressId,
                        scene: 304,
                        channel: ''
                      });
                    }
                    const detailed =
                      (item.provinceName || '') +
                      (item.cityName || '') +
                      (item.areaName || '') +
                      (item.streetName || '') +
                      (item.communityName || '') +
                      (item.Name || '') +
                      decyptAddress;
                    runInAction(() => {
                      this.deliveryAddress = {
                        ...item,
                        address: decyptAddress,
                        detailed
                      };
                    });
                  }
                };
                promiseList.push(case1());

                break;
              }

              case 2: {
                this.pickUpInfo = item || {};
                break;
              }
              case 3: {
                let case3 = async () => {
                  this.storeInfo = item;
                  let decyptAddress = item.address;
                  if (!!item.address && item.address.indexOf('*') != -1) {
                    let decyptAddress = await Stores.AppMod.getDecyptMsg({
                      id: item.id,
                      scene: 301,
                      channel: ''
                    });
                  }
                  runInAction(() => {
                    this.storeInfo = {
                      ...item,
                      address: decyptAddress,
                      detailed:
                        (item.provinceName || '') +
                        (item.cityName || '') +
                        (item.areaName || '') +
                        (item.streetName || '') +
                        (item.communityName || '') +
                        (decyptAddress || '')
                    };
                  });
                };
                promiseList.push(case3());

                break;
              }
              default: {
                break;
              }
            }
          });
        }

        yield Promise.all(promiseList);

        if (!this.deliveryType) {
          const deliveryItem = this.deliveryList.find((item) => {
            return !item.disabled;
          });
          if (Stores.AppMod.isStaff) {
            this.setDeliveryType(2);
          } else {
            this.setDeliveryType(deliveryItem ? parseInt(deliveryItem.type) : '');
          }
        }
      }
    } catch (e) {
      console.log('err', e);
    }
  });

  getTip(type) {
    const deliveryData = this.deliveryList.find((item) => {
      return item.type == type;
    });

    const { payAmountBegin, payAmountEnd } = deliveryData || {};
    let tip = '';

    const payAmountBeginPrice = Util.formatMoney({
      value: payAmountBegin,
      showPrefix: false,
      showCurrencyName: true,
      precision: 0
    });
    const payAmountEndPrice = Util.formatMoney({
      value: payAmountEnd,
      showPrefix: false,
      showCurrencyName: true,
      precision: 0
    });

    if (payAmountBegin != null) {
      if (payAmountEnd != null) {
        tip = `限订单金额${payAmountBeginPrice}（含）以上${payAmountEndPrice}（含）以下可使用`;
      } else {
        tip = `限订单金额${payAmountBeginPrice}（含）以上可使用`;
      }
    } else if (payAmountEnd != null) {
      tip = `限订单金额${payAmountEndPrice}（含）以下可使用`;
    }

    return tip;
  }

  @action
  setDeliveryType(type) {
    console.log('setDeliveryType', type);
    this.deliveryType = type;
    // 获取运费
    this.getFreight();
    // Util.getLocalCache('virtualFreeFreight')!==1 && this.getFreight();
    // 新的获取运费值
    // this.getNewFreight();
    // 获取优惠券
    !this.isFromSelectMall && this.getCouponList();

    // 切换收货方式，清空国际物流运费类型
    this.internationalFreightType = '';
  }

  getNewFreight = flow(function* () {
    Toast.loading('请稍候', 100);
    const { confirmParams } = this;
    const { userType } = Stores.AppMod;
    const { url, params } = confirmParams || {};
    const newParams = {
      ...params,
      areaCode: this.deliveryAddress.cityCode,
      deliveryType: this.deliveryType
    };
    try {
      // 将请求存储在mobx
      let { data, resultCode, resultMsg } = yield Serv.confirmOrder(url, newParams);
      const { freightAmount = 0 } = data;
      Toast.hide();
      if (
        (this.dgMemberInfo && userType != 2) ||
        [5, 6, 7, 8].includes(+this.orderType) ||
        [3, 5].includes(+userType)
      ) {
        this.freightAmountForShow = freightAmount || 0;
        return;
      }
      this.orderInfo.originFreightAmount = freightAmount || 0;
      this.orderInfo.freightAmount = freightAmount || 0;
    } catch (e) {}
  });

  /**
   * 获取运费
   */
  getFreight = flow(function* () {
    const virtualPointId = Util.getLocalCache('virtualPointId');
    const { freightAmount } = this.orderInfo;
    const { userType } = Stores.AppMod;
    // 店铺入口（代客下单、新客注册、老客升级、开店）和店长身份暂时屏蔽运费，后续要改回来
    // if (this.dgMemberInfo || [5, 6, 7, 8].includes(+this.orderType) || [3, 5].includes(+userType)) {
    //   return;
    // }
    if (this.selectedCoupons.length > 0 && this.isSpecial) {
      this.queryCouponCreateBv();
    } else {
      this.isSpecialBv = 0;
    }
    // 如果还没选择地址，不计算运费
    // 如果是享包邮订单，不计算运费
    if (!this.deliveryAddress || !this.deliveryAddress.cityCode || this.freeShippingNo) {
      this.orderInfo.freightAmount = 0;
      return;
    }
    // 自提或店铺代收 个人礼品仓 新仓 不查运费  5个人云仓是否加入判断待确认(app也一样) (叶秋表示配置问题不会出现)
    if (
      !this.deliveryType ||
      this.deliveryType == 2 ||
      this.deliveryType == 3 ||
      this.deliveryType == 7 ||
      this.deliveryType == 8
    ) {
      this.orderInfo.freightAmount = 0;
      return;
    }
    // 赋百龄 提货
    if (this.isXBLPickUpGoods) {
      this.orderInfo.freightAmount = 0;
      return;
    }
    let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
    try {
      confirmItems = JSON.parse(confirmItems) || [];
    } catch (e) {}

    const { totalAmount, activityDiscountAmount } = this.orderInfo;
    // 每次选择完优惠券，重新请求接口，带上这两个参数，重新获得运费
    let couponFreight = 0;
    let availableItemIds = [];
    let userCouponList = [];
    this.selectedCoupons.forEach((item) => {
      const coupon = this.couponInfo.usableList[item];
      if (coupon.freightSet == 1) {
        couponFreight += coupon.freightAmount || 0;
        availableItemIds = [...availableItemIds, ...(coupon.availableItemIds || [])];
      }
      userCouponList = [...userCouponList, coupon.userCouponCode];
    });

    let params = {
      items: confirmItems,
      areaCode: this.deliveryAddress.cityCode,
      deliveryType: this.deliveryType,
      orderProperty: this.orderProperty,
      totalOrderAmount: this.isFromSelectMall
        ? 0
        : totalAmount - activityDiscountAmount - this.couponDiscount,
      // totalOrderAmount: parseInt(this.payAmount) + parseInt(freightAmount),
      couponFreight,
      availableItemIds,
      userCouponList
    };
    this.directPayFreight && (params.directPayFreight = this.directPayFreight);
    !!Util.getLocalCache('virtualPointId') &&
      (params.virtualPointId = Util.getLocalCache('virtualPointId'));
    params.targetVirtualPlanId = Util.getLocalCache('targetVirtualPlanId');
    console.log(params);
    // dgStatus（代客状态 0.自购 1.店铺代客 2.会员代客）
    // cloudWarehouseState（云仓场景 0.非云仓 1.云仓）
    if (Util.getLocalCache(Config.localStorageKeys.xbl_cloud_warehouse)) {
      params.dgStatus = 1;
      params.cloudWarehouseState = 1;
    }
    try {
      const url = this.isFromSelectMall
        ? 'biz/tradecore/trade/calculate/integral/freight'
        : 'biz/tradecore/trade/calculate/freight';
      const { data, extFields } = yield Serv.getFreight(params, url);

      // if ((this.dgMemberInfo && userType != 2) || [5, 6, 7, 8].includes(+this.orderType) || [3, 5].includes(+userType)) {
      //   this.freightAmountForShow = data || 0;
      //   return;
      // }

      this.orderInfo.originFreightAmount = data;
      this.orderInfo.freightAmount = data;

      // 如果extFields中存在baseFreight和extraFreight字段，则分别设置
      if (extFields) {
        if (extFields.baseFreight !== undefined) {
          this.orderInfo.originFreightAmount = extFields.baseFreight;
          this.orderInfo.freightAmount = extFields.baseFreight;
        }
        if (extFields.extraFreight !== undefined) {
          this.orderInfo.extraFreight = extFields.extraFreight;
        } else {
          this.orderInfo.extraFreight = 0;
        }
      } else {
        this.orderInfo.extraFreight = 0;
      }

      let ids = (this.orderInfo.activityDiscountInfo || []).map((item) => item.activityId);
      if (data) {
        yield this.getFreightCouponList(ids.join(','), { items: this.orderInfo.items });
        this.selectDefaultFreightCoupon({ freightAmount: data });
      }
    } catch (e) {
      console.log('getFreight e', e);
    }
  });

  // 顺手买一单 重新计算运费
  easyBuyCalculatFreight = flow(function* () {
    const easeBuyItems = this.selectedEaseBuyItems || [];
    if (!easeBuyItems.length) {
      this.orderInfo.easeBuyFreight = 0;
      return;
    }
    if (!this.deliveryAddress || !this.deliveryAddress.cityCode || !this.deliveryType) {
      this.orderInfo.easeBuyFreight = 0;
      return;
    }

    const totalAmount = easeBuyItems.reduce((acc, item) => acc + item.itemPrice, 0);

    const params = {
      items: this.selectedEaseBuyItems,
      areaCode: this.deliveryAddress.cityCode,
      deliveryType: this.deliveryType,
      orderProperty: this.orderProperty,
      totalOrderAmount: totalAmount,
      couponFreight: 0,
      availableItemIds: [],
      userCouponList: []
    };

    try {
      const url = 'biz/tradecore/trade/calculate/freight';
      const { data } = yield Serv.getFreight(params, url);
      this.orderInfo.easeBuyFreight = data || 0;
    } catch (error) {}
  });

  /**
   * 检查所属店铺是否可用
   */
  checkBelongShop = flow(function* (belongShop) {
    try {
      const { data } = yield Serv.checkBelongShop({
        code: belongShop || this.belongShop
      });
      if (data.memberName) {
        this.shopName = data.memberName;
        return data.memberName;
      }
      this.availableBelongShop = true;
    } catch (err) {}
  });

  /**
   * 支付金额
   */
  @computed
  get payAmount() {
    let {
      freightAmount,
      totalAmount,
      activityDiscountAmount = 0,
      depositAmount = 0,
      cheapAmount,
      randomCheapAmount,
      tailAmount = 0,
      couponsAmount,
      extraFreight = 0
    } = this.orderInfo;
    // 虚拟资格 金额根据运费
    if (
      localStorage.getItem('isCloudWarehousecOrder') == 1 ||
      !!Util.getLocalCache('virtualPointId')
    ) {
      return freightAmount;
    }
    // console.log(JSON.stringify(this.orderInfo), 444444, this.advanceSaleStatus, this.activityType)
    const { productList } = this;
    // 商品原价总和
    // let originTotal = [0, ...productList].reduce(
    //   (pre, next) => pre + next.totalDiscountAmount,
    // );
    let originTotal = (totalAmount * 100 - activityDiscountAmount * 100) / 100;

    if (this.activityType == activityTypeMap.advanceSale) {
      if (this.advanceSaleStatus == advanceSaleStatusMap.PAYFORDEPOSIT) {
        return depositAmount;
      }
      originTotal = tailAmount;
      // originTotal = Math.round(totalAmount - activityDiscountAmount - depositAmount)
    } else if (this.activityType == activityTypeMap.groupBuy) {
      originTotal = (totalAmount * 100 - activityDiscountAmount * 100) / 100;
    }
    // 商品优惠之后价格总和
    let realAmount = (originTotal * 100 - this.couponDiscount * 100) / 100;
    const hasIncPrice =
      (get(this.orderInfo, 'cheapItemList') || []).length > 0 ||
      (get(this.orderInfo, 'randomCheapItemList') || []).length > 0;
    // 有加价购时，加上加价购金额
    let payAmount = !hasIncPrice
      ? realAmount
      : (realAmount + (cheapAmount || 0) + (randomCheapAmount || 0)).toFixed(2);

    payAmount = payAmount < 0 ? 0 : payAmount * 1;
    if (Stores.AppMod.userInfo.cloudStorageTag == 1 && this.deliveryType == 5) {
      freightAmount = 0;
    }

    if (this.voucherInfo && this.voucherInfo.voucherAssignAmount === 1) {
      payAmount = this.voucherInfo.voucherAmount || 0;
    }
    if (extraFreight > 0) {
      payAmount += extraFreight;
    }

    return (payAmount + freightAmount).toFixed(2);
  }

  /**
   * bv合计
   */
  get totalBv() {
    const totalBv = [0, ...this.productList].reduce((pre, next) => {
      return pre + next.realBv;
    });
    const { bvMode, bv, reduceBv = 0 } = this.bvReceiveData;
    console.log(
      this.isUseCouponCalculate,
      '🚀 ~ gettotalBv ~ this.bvReceiveData:',
      this.bvReceiveData
    );

    // 选择的优惠券中存在bv计算规则等于 0: “全部减免”或 1: “按优惠计算”，则根据优惠券bv计算，不走卡类型bv计算
    if (this.isUseCouponCalculate) {
      return totalBv;
    }

    // 计算差价
    // 1-固定bv
    if (bvMode == 1) {
      return bv;
    }
    // 0-根据产品设置
    if (bvMode == 0) {
      return floatTool.subtract(totalBv, reduceBv) < 0 ? 0 : floatTool.subtract(totalBv, reduceBv);
    }
    // 2-根据订单实付金额
    if (bvMode === 2) {
      const freightAmount = (this.orderInfo && this.orderInfo.freightAmount) || 0;
      const bv = Math.floor(floatTool.subtract(this.payAmount, freightAmount));
      this.bvReceiveData.bv = bv;
      return bv;
    }

    // 加价购要加上加购品的bv
    if (this.orderInfo && this.orderInfo.cheapItemList) {
      let newTotalBv = totalBv;
      (this.orderInfo.cheapItemList || []).forEach((item) => {
        newTotalBv += item.bvIncrease * item.num;
      });
      return newTotalBv;
    }
    // 不计算差价
    return totalBv;
  }

  getAddOrderItems(newItemList) {
    const { itemList } = this;
    let orderItems = [];

    if (newItemList && newItemList.length > 0) {
      orderItems = newItemList;
    } else {
      let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
      try {
        confirmItems = JSON.parse(confirmItems) || [];
      } catch (e) {}

      orderItems = itemList.map((item) => {
        const data = confirmItems.find((confirmItem) => {
          return confirmItem.itemSerial == item.itemSerial;
        });

        return { ...item, ...data };
      });
    }
    if (this.sourceTag) {
      const isAllNull = (orderItems || []).every((item) => !item.referrer);
      if (isAllNull) {
        orderItems = orderItems.map((item) => {
          return { ...item, referrer: this.sourceTag };
        });
      }
    }
    console.log(orderItems, 'orderItemsorderItemsorderItemsorderItemsorderItems');
    return orderItems;
  }

  // 获取更多需要添加的参数
  getMoreParams(v) {
    let rv = v;
    // 顺手买一单code
    try {
      const { shareUserId } = v || {};
      const sud = sessionStorage.getItem('shareUserByCardNo') || '';
      rv = sud && !shareUserId ? { ...v, shareUserId: sud } : v;
    } catch (error) {}
    !!this.easyBuyCode && (rv.easyBuyCode = this.easyBuyCode);
    return rv;
  }

  /**
   * 获取下单基本参数
   */
  getOrderParams(newItemList = '') {
    const {
      orderType,
      deliveryAddress,
      deliveryType,
      orderInfo,
      pickUpInfo,
      storeInfo,
      dgUserId,
      pickUpSelfAddress
    } = this;
    const { orderBv, totalAmount, itemNumber } = orderInfo;
    const { userType, userInfo } = Stores.AppMod;
    const { healthConsultantBelongShop, healthConsultantShopCode, healthConsultantNum } =
      userInfo || {};
    const orderSources = {
      1: 'CUSTOMER',
      2: 'MEMBER',
      3: 'SHOP',
      5: 'SHOP'
    };
    // 判断普客是否是走替换shopCode
    let norShopCode = '';
    if (!!healthConsultantNum && userType == 1) {
      norShopCode = healthConsultantShopCode || healthConsultantBelongShop;
    }
    console.log('deliveryType', deliveryType, typeof deliveryType);

    let paramsReq = {
      deliveryAddress:
        // deliveryType == 1
        [1, 7, 8].includes(+deliveryType)
          ? { ...deliveryAddress, deliveryId: deliveryAddress.userAddressId }
          : deliveryType == 3
            ? { ...storeInfo, deliveryId: storeInfo.id }
            : pickUpInfo,
      alternateDeliveryAddress:
        deliveryType == 2
          ? {
              ...(pickUpSelfAddress ? pickUpSelfAddress.deliveryAddress : null),
              deliveryId: pickUpSelfAddress && pickUpSelfAddress.deliveryAddress.userAddressId
            }
          : null,
      deliveryType,
      shopCode: deliveryType == 3 ? storeInfo.shopCode : norShopCode || this.belongShop,
      orderItems: this.getAddOrderItems(newItemList),
      orderType: orderType || '1',
      orderProperty: this.orderProperty,
      payAmount: this.payAmount,
      orderBv,
      shopCart: Util.getLocalCache(Config.localStorageKeys.shop_isShopCart) || 0,
      totalAmount,
      totalItemNum: itemNumber,
      // 下单来源方式:CUSTOMER：普客下单，MEMBER：会员下单，SHOP：店铺下单
      // (但符合以下情况之一的一律传MEMBER：① 店铺身份的非代客订单，② 店铺身份的会员新客注册)
      orderSource:
        [3, 5].includes(+userType) && (!dgUserId || orderType == 5)
          ? 'MEMBER'
          : orderSources[`${userType}`],
      dgMemberCode: this.dgMemberInfo ? this.dgMemberInfo.memberCard : '',
      dgMemberName: this.dgMemberInfo ? this.dgMemberInfo.memberName : '',
      bizGiveawayReqDto: Util.getLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto) || {},
      agreementCode: this.agreenMentCode, // 是否勾选协议
      couponList: this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id)
    };

    if (this.orderInfo.randomGiftList && this.orderInfo.randomGiftList.length > 0) {
      // 随机赠品
      this.orderInfo.randomGiftList.forEach((o) => {
        if (o.giftType === 1) {
          paramsReq.bizGiveawayReqDto.freeItem = paramsReq.bizGiveawayReqDto.freeItem || [];
          paramsReq.bizGiveawayReqDto.freeItem.push({
            viewId: '',
            itemName: o.blessingBagAlias,
            itemNum: o.giftCount,
            itemPrice: o.salePrice,
            itemSerial: o.itemId,
            skuSerial: o.skuId,
            activityIdList: [o.activityId],
            groupKey: o.groupKey
          });
        } else {
          paramsReq.bizGiveawayReqDto.giftList = paramsReq.bizGiveawayReqDto.giftList || [];
          paramsReq.bizGiveawayReqDto.giftList.push({
            giftType: o.giftType,
            giftId: o.itemId,
            itemName: o.blessingBagAlias,
            itemNum: o.giftCount,
            giftNum: o.giftCount,
            activityIdList: [o.activityId],
            groupKey: o.groupKey
          });
        }
      });
    }
    // if (this.orderInfo.cheapItemList &&
    //   this.orderInfo.cheapItemList.length > 0
    // ) {
    //   paramsReq.bizGiveawayReqDto.cheapItem = this.orderInfo.cheapItemList || [];
    // }
    if (this.orderInfo.randomCheapItemList && this.orderInfo.randomCheapItemList.length > 0) {
      // 随机加价购商品
      this.orderInfo.randomCheapItemList.forEach((o) => {
        paramsReq.bizGiveawayReqDto.cheapItem = paramsReq.bizGiveawayReqDto.cheapItem || [];
        paramsReq.bizGiveawayReqDto.cheapItem.push({
          activityIdList: o.activityIdList,
          groupKey: o.groupKey,
          itemNum: o.num,
          itemPrice: o.price,
          itemSerial: o.itemId,
          skuSerial: o.skuId
        });
      });
    }

    // 是否续约礼订单, 0=不是, 1=是
    if (this.renewGiftOrderFlag == 1) {
      paramsReq.renewGiftOrderFlag = 1;
    }

    // // 处理满赠的bizGiveawayReqDto
    // let bizGiveawayReqDto = Util.getLocalCache(Config.localStorageKeys.shop_bizGiveawayReqDto) || {};
    // let freeItem = get(bizGiveawayReqDto, 'freeItem');
    // if (freeItem && freeItem.length > 0) {
    //   paramsReq.bizGiveawayReqDto = bizGiveawayReqDto;
    // }
    const $params = this.getMoreParams(paramsReq);
    return $params;
  }

  /**
   * 创建订单
   * noOrderToOpenCard 0元开卡！！！！！
   */
  addOrder = flow(function* (
    newItemList = '',
    noOrderToOpenCard,
    isShareOrder,
    ment = null,
    activityLink = null,
    addActivityId = null,
    applyUserInfo = null,
    sourceNo = '',
    sourceChannel = '',
    globalSaleMode = '', // 产品属性
    dreamPlanRelateCard = '', // 助梦计划
    shopCart = '',
    extra = {}
  ) {
    console.log('activityLinkactivityLink', globalSaleMode, activityLink);

    const bvData = this.bvReceiveData;
    const { orderType, valueList } = this;
    let url = '';
    let params = {};
    let isSmartCard = '';
    if (Stores.AppMod.isSmartCard.id) {
      isSmartCard = Stores.AppMod.isSmartCard;
    }
    const orderParams = this.getOrderParams(newItemList);
    console.log('orderParams', orderType, toJS(orderParams));
    console.log('this.deliveryTypessss', this.deliveryType);

    if (orderParams.deliveryAddress.deliveryType == 2 || [7, 8].includes(+this.deliveryType)) {
      // 解密手机号
      if (orderParams.deliveryAddress.deliveryMobile.indexOf('*') != -1) {
        orderParams.deliveryAddress.deliveryMobile = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 206,
          channel: ''
        });
      }
      // 解密姓名
      if (
        orderParams.deliveryAddress.deliveryName &&
        orderParams.deliveryAddress.deliveryName.indexOf('*') != -1
      ) {
        orderParams.deliveryAddress.deliveryName = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 101,
          channel: ''
        });
      }
    }
    console.log('orderType>>>>>>', orderType);
    switch (`${orderType}`) {
      case '3': {
        // 自主开卡
        url = 'user/register/submitRegisterCardOrder';
        if (noOrderToOpenCard == 1) {
          // 0 元开卡
          url = 'user/register/submitRegisterCardOrderWithZero';
        }

        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        let registerCardReqDto =
          Util.getLocalCache(Config.localStorageKeys.member_applyCardMsg) || {};
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);
        if (this.belongArea) {
          registerCardReqDto = {
            ...registerCardReqDto,
            saleConsultantNum: this.sale,
            belongArea: this.belongArea
          };
        }
        if (!registerCardReqDto.saleConsultantNum) {
          registerCardReqDto.saleConsultantNum =
            registerCardReqDto.healthConsultantNum || undefined;
        }
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');

        if (applyUserInfo) {
          registerCardReqDto = {
            ...registerCardReqDto,
            ...(applyUserInfo
              ? {
                  healthConsultantNum: applyUserInfo.healthConsultantNum,
                  saleConsultantNum: applyUserInfo.healthConsultantNum,
                  realName: applyUserInfo.realName,
                  name: applyUserInfo.realName,
                  identityType: applyUserInfo.identityType,
                  identityCard: applyUserInfo.identityCard,
                  birthday: applyUserInfo.birthday,
                  sex: applyUserInfo.sex,
                  nation: applyUserInfo.nation
                }
              : {})
          };
        }

        if (noOrderToOpenCard == 1) {
          // 0 元开卡
          params = {
            createOrderReqDto: {},
            registerCardReqDto: {
              ...registerCardReqDto,
              // 0元开卡
              ...(localStorage.getItem('noOrderToOpenCard') == 1
                ? {
                    cardTypeId: localStorage.getItem('noOrderToOpenCardId')
                  }
                : {})
            },
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };
          if (registerCardReqDto.password) {
            localStorage.setItem('noOrderToOpenpwd', window.atob(registerCardReqDto.password));
          }
        } else {
          params = {
            benefitReqDtos: JSON.parse(confirmItems),
            createOrderReqDto: { ...orderParams, ...bvData },
            registerCardReqDto,
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };
        }
        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }

        break;
      }
      case '4': {
        // 会员自主升级和维多益会员代课升级
        const localMemInfo = Util.getLocalCache('store_agentUpgradeMember') || {};
        const memberForUpdate = Util.getLocalCache('memberForUpdate');
        url = 'user/upgrade/submitUpgradeCardOrder';
        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        if (this.needForm) {
          orderParams.newFormInfo = this.cellsForm;
        }
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);
        let newObject = { ...orderParams, ...bvData };
        params = {
          benefitReqDtos: JSON.parse(confirmItems),
          createOrderReqDto: {
            ...newObject,
            ...(memberForUpdate
              ? {
                  dgMemberCode: localMemInfo.cardCode,
                  dgMemberName: localMemInfo.realName,
                  dgStatus: 2
                }
              : {})
            // cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
          },
          bizUpgradeCardReqDto: {
            cardCode: memberForUpdate ? localMemInfo.cardCode : Stores.AppMod.userInfo.cardCode,
            channel: memberForUpdate ? 4 : 1
          },
          confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
        };

        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }
        break;
      }
      case '5': {
        // 会员新客注册
        url = 'user/register/submitRegisterCardOrder';
        if (noOrderToOpenCard == 1) {
          // 0 元开卡
          url = 'user/register/submitRegisterCardOrderWithZero';
        }
        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        let registerCardReqDto =
          Util.getLocalCache(Config.localStorageKeys.member_agentApplyCardMsg) || {};
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');
        // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        if (this.dgMemberInfo) {
          orderParams.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        let newObject = { ...orderParams, ...bvData };
        if (this.belongArea) {
          registerCardReqDto = {
            ...registerCardReqDto,
            saleConsultantNum: this.sale,
            belongArea: this.belongArea
          };
        }
        if (!registerCardReqDto.saleConsultantNum) {
          registerCardReqDto.saleConsultantNum =
            registerCardReqDto.healthConsultantNum || undefined;
        }
        const menberHelpUserId =
          Util.getLocalCache(Config.localStorageKeys.menber_helpUserId) || {};
        if (!registerCardReqDto.password) {
          registerCardReqDto.password = rstr2b64((menberHelpUserId.phone || '123456').slice(-6));
        }
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);

        if (noOrderToOpenCard == 1) {
          // 0 元开卡
          params = {
            createOrderReqDto: {},
            registerCardReqDto: {
              ...registerCardReqDto,
              // 0元开卡
              ...(localStorage.getItem('noOrderToOpenCard') == 1
                ? {
                    cardTypeId: localStorage.getItem('noOrderToOpenCardId')
                  }
                : {})
            },
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };
          localStorage.setItem('noOrderToOpenpwd', window.atob(registerCardReqDto.password));
        } else {
          params = {
            benefitReqDtos: JSON.parse(confirmItems),
            createOrderReqDto: newObject,
            registerCardReqDto,
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };

          if (Stores.AppMod.isCXY || Stores.AppMod.isWY) {
            const modifySaleTag = Util.getLocalCache(Config.localStorageKeys.modifySaleTag);
            if (modifySaleTag) {
              params.modifySaleTag = 1;
            }
          }
        }
        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }
        break;
      }
      case '6': {
        // 会员申请开店
        url = 'store/order/submit/first';
        const applyStoreMsg = Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg);
        const name = localStorage.getItem('MSZname');
        applyStoreMsg.shopContactInfoDto.name = name;
        const certificationList = Util.getLocalCache('certificationList');
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');
        let { storeTypeId } = applyStoreMsg.shopContactInfoDto || {};
        // storeCreateReqDto.certificationList
        params = {
          host: Config.HOST_STORE,
          confirmReqDto: {
            userId: applyStoreMsg.registerCardReqDto.userId,
            channel: 3,
            unLogin: applyStoreMsg.registerType == 0,
            orderType: 5,
            orderProperty: 1,
            items: this.getAddOrderItems(newItemList),
            agreementCode: this.agreenMentCode,
            bizGiveawayReqDto: orderParams.bizGiveawayReqDto || undefined
          },
          storeCreateReqDto: {
            ...applyStoreMsg,
            ...(certificationList ? { certificationList } : {}),
            deliveryType: this.deliveryType
          },
          deliveryAddressReqDto: applyStoreMsg.shopContactInfoDto.deliveryAddress,
          storeTypeId: storeTypeId || localStorage.getItem('storeTypeIdMSZ')
        };
        if (this.detectionRechargeCardCode) {
          params.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }
        break;
      }
      case '7': {
        // 店铺新客注册
        url = 'valetOpenCard/submitValetOpenCardOrder';
        if (noOrderToOpenCard == 1) {
          url = 'valetOpenCard/submitValetOpenCardOrderWithZero';
        }
        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');
        const storeAgentApplyCardMsg =
          Util.getLocalCache(Config.localStorageKeys.member_storeAgentApplyCardMsg) || {};
        // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        if (this.dgMemberInfo) {
          orderParams.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);
        let newObject = storeAgentApplyCardMsg;
        if (this.belongArea) {
          newObject = {
            ...newObject,
            saleConsultantNum: this.sale,
            belongArea: this.belongArea
          };
        }

        if (!newObject.saleConsultantNum) {
          newObject.saleConsultantNum = newObject.healthConsultantNum || undefined;
        }
        const storeAgentUpgradeMember =
          Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
        if (!newObject.password) {
          newObject.password = rstr2b64((storeAgentUpgradeMember.phone || '123456').slice(-6));
        }

        if (noOrderToOpenCard == 1) {
          // 0 元开卡
          params = {
            host: Config.HOST_STORE,

            createOrderReqDto: {},
            bizValetCardReqDto: {
              ...newObject,
              // 0元开卡
              ...(localStorage.getItem('noOrderToOpenCard') == 1
                ? {
                    cardTypeId: localStorage.getItem('noOrderToOpenCardId')
                  }
                : {})
            },
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };
          localStorage.setItem('noOrderToOpenpwd', window.atob(newObject.password));
        } else {
          params = {
            host: Config.HOST_STORE,
            benefitReqDtos: JSON.parse(confirmItems),
            createOrderReqDto: {
              ...orderParams,
              ...bvData,
              cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0
            },
            bizValetCardReqDto: newObject,
            confirmReqDto: {
              userId: Stores.AppMod.userInfo.id,
              channel: 2
            },
            confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
          };

          if (Stores.AppMod.isCXY || Stores.AppMod.isWY) {
            const modifySaleTag = Util.getLocalCache(Config.localStorageKeys.modifySaleTag);
            if (modifySaleTag) {
              Util.setLocalCache(Config.localStorageKeys.modifySaleTag, '');
              params.modifySaleTag = 1;
            }
          }
        }
        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }
        break;
      }
      case '8': {
        // 老客升级
        url = 'valetUpgrade/submitUpgradeCardOrder';
        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');
        const agentUpgradeMember =
          Util.getLocalCache(Config.localStorageKeys.store_agentUpgradeMember) || {};
        if (this.needForm) {
          orderParams.newFormInfo = this.cellsForm;
        }
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);
        // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        if (this.dgMemberInfo) {
          orderParams.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        }
        let newObject = {
          ...orderParams,
          ...bvData,
          cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0
        };
        params = {
          host: Config.HOST_STORE,
          benefitReqDtos: JSON.parse(confirmItems),
          createOrderReqDto: newObject,
          bizUpgradeCardReqDto: {
            passengerCardCode: agentUpgradeMember.cardCode,
            channel: 3
          },
          confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
        };
        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }
        break;
      }
      case '18': {
        // 虚拟资格 注册开卡
        url = 'valetOpenCard/submitValetOpenCardOrder';
        let confirmItems = Util.getLocalCache(Config.localStorageKeys.shop_confirmItems);
        // let giftList = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_giftItems) || '[]');
        const virtualApplyCardMsg =
          Util.getLocalCache(Config.localStorageKeys.virtual_applyCardMsg) || {};
        // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        // if (!!this.dgMemberInfo) {
        //   orderParams.dgStatus = this.dgMemberInfo.origin == 'member' ? 2 : 1;
        // }
        orderParams.dgStatus = 2;
        orderParams.orderItems = this.filteractivity(this.newItemResDtos || []);
        let newObject = { ...virtualApplyCardMsg };
        if (this.belongArea) {
          newObject = {
            ...newObject,
            ...virtualApplyCardMsg,
            saleConsultantNum: this.sale,
            belongArea: this.belongArea
          };
        }
        if (!newObject.saleConsultantNum) {
          newObject.saleConsultantNum = newObject.healthConsultantNum || undefined;
        }
        params = {
          host: Config.HOST_STORE,
          benefitReqDtos: JSON.parse(confirmItems),
          createOrderReqDto: {
            virtualPointId: Util.getLocalCache('virtualPointId'),
            targetVirtualPlanId: Util.getLocalCache('targetVirtualPlanId'),
            ...orderParams,
            ...bvData,
            cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0
          },
          bizValetCardReqDto: newObject,
          confirmReqDto: {
            userId: Stores.AppMod.userInfo.id,
            channel: 2
          },
          orderType: 3,
          confirmReqId: Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || '' // 开卡、升级下单慢接口优化加传
        };
        // 礼包里选择了AI检测产品，且有充值卡号的清空下需要传充值的会员卡号
        if (this.detectionRechargeCardCode) {
          params.createOrderReqDto.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }

        break;
      }

      default: {
        const shareId = localStorage.getItem('shareIdVistor') || undefined;
        // 普通下单
        url = 'biz/tradecore/trade/add';

        params = {
          shareSource: 1,
          shareId,
          cloudWarehousecOrder: localStorage.getItem('isCloudWarehousecOrder') || 0,
          ...orderParams,
          deliveryType: this.deliveryType,
          couponList: this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id),
          freightCouponList:
            this.selectedFreightCoupon >= 0
              ? [this.freightCouponInfo.usableList[this.selectedFreightCoupon].id]
              : [],
          ment,
          shopCart
        };
        if (activityLink && activityLink != 'undefined') {
          params.bizActivityExclusiveLinkReqDto = {
            activityId: addActivityId,
            activityLink
          };
        }
        const newParams = this.calParmas({
          val: [
            { key: 'subActivityId', value: 'subActivityId' },
            { key: 'subCardCode', value: 'cardCode' },
            { key: 'subActivityChannel', value: 'subActivityChannel' }
          ],
          params
        });
        params = newParams;
        // 店长待客下单逻辑
        this.subActivityId && (params.subActivityId = this.subActivityId);
        this.subCardCode && (params.subCardCode = this.subCardCode);

        if (this.discount && !this.isVipRebuy) {
          url = 'biz/tradecore/retail/trade/add';
          params.discount = this.discount;
        }
        if (this.isVipRebuy) {
          params.orderType = 10;
          delete params.discount;
        }
        if (isSmartCard.id) {
          params.saleByBusinessFlag = 1;
          params.shareUserId = isSmartCard.id;
        }
        if (this.birthday) {
          params.birthday = this.birthday;
        }

        // 如果是代客的话，按之前的逻辑，默认为 店铺代客
        // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
        if (this.dgMemberInfo) {
          let org = this.birthday
            ? { 2: 'member', 3: 'shop' }[Stores.AppMod.userType] || 'shop'
            : this.dgMemberInfo.origin;
          params.dgStatus = org == 'member' ? 2 : 1;
        }

        // 享包邮订单需要传主单的单号
        if (this.freeShippingNo) {
          params.freeShippingNo = this.freeShippingNo;
        }

        // 甄选商城订单
        if (this.isFromSelectMall) {
          params.dgStatus = 0;
          params.orderType = 30;
          // params.orderProperty = '1';
          params.orderProperty = (this.orderProperty || '').toString();
        }
        if (sourceNo) {
          params.sourceNo = sourceNo;
        }
        if (sourceChannel) {
          params.sourceChannel = sourceChannel;
        }

        if (this.detectionRechargeCardCode) {
          params.extendReqDto = {
            giveUser: this.detectionRechargeCardCode
          };
        }

        // 三生豆订单
        if (this.isBean) {
          url = 'biz/tradecore/bean/trade/add';
        }

        // 宫主会订单
        if (this.isPriaItem) {
          url = 'biz/tradecore/priaPoints/trade/add';
        }
      }
    }

    this.belongArea = '';
    this.sale = '';
    params.saleMode = globalSaleMode || '';
    params.dreamPlanRelateCard = dreamPlanRelateCard || '';
    console.log('paramssdf', params);

    // 顺手买一单
    const easeBuyItems = this.selectedEaseBuyItems;
    if (easeBuyItems.length) {
      const { easeBuyFreight } = this.orderInfo;
      params.orderItems = params.orderItems.concat(easeBuyItems);
      params.payAmount = [floatTool.add(params.totalAmount, easeBuyFreight), ...easeBuyItems]
        .reduce((pre, next) => pre + next.itemPrice)
        .toFixed(2);
      params.totalAmount = [
        floatTool.add(params.totalAmount, easeBuyFreight),
        ...easeBuyItems
      ].reduce((pre, next) => pre + next.itemPrice);
    }

    if (this.needForm) {
      Object.assign(params, {
        formInfo: {
          certificateName: this.ziGeCertificateName || this.ziGeMemberName,
          dateStr: this.ziGeday,
          dateType: this.ziGedataType,
          mateName: this.ziGePartnerName,
          name: this.ziGeMemberName
        },
        newFormInfo: this.cellsForm
      });
    }

    // 如果是有店主福利分享人
    if (this.invitationUserId) {
      params.invitationUserId = this.invitationUserId;
    }

    // 国际物流运费类型 1-直接补 2-享包邮
    if (this.isShowInterNationalFreightWay && this.internationalFreightType) {
      // 店铺代客注册或升级传参在createOrderReqDto中
      if (`${orderType}` === '7' || `${orderType}` === '8') {
        params.createOrderReqDto.internationalFreightType = this.internationalFreightType;
      } else {
        params.internationalFreightType = this.internationalFreightType;
      }
    }

    let provinceName = get(orderParams, 'deliveryAddress.provinceName') || '';
    let minAmount =
      provinceName.indexOf('新疆') != -1 || provinceName.indexOf('西藏') != -1 ? 1700 : 500;

    let isProfitSharing = false;
    isProfitSharing = params.orderItems && params.orderItems.find((v) => v.code == 'LB593');
    params.isShareOrder = isShareOrder || false;
    // #region 合利共盈礼包订单，需要在createOrderReqDto中传参
    if (
      this.freeShippingItem &&
      this.freeShippingItem.length &&
      this.internationalFreightType == internationalFreightTypeMap.FREE_SHIPPING
    ) {
      const { createOrderReqDto = {} } = params;
      params.createOrderReqDto = createOrderReqDto;
      // 享包邮配置编号，用于校验配置，来源于享包邮产品列表接口
      params.createOrderReqDto.freeShippingConfigCode = this.freeShippingConfigCode || '';
      // 享包邮产品列表
      params.createOrderReqDto.freeShippingOrderItems = this.changeFreeShippingOrderItems();
    }
    // #endregion 合利共盈礼包订单，需要在createOrderReqDto中传参
    console.log('url123123', isProfitSharing, url, toJS(params));
    if (isProfitSharing) {
      Modal.alert(
        '温馨提示',
        `订购合利共盈礼包，需绑定《御坊堂养生馆》后公司才会安排发货，且收货地址为绑定的养生馆地址`,
        [{ text: '确定', onPress: () => this.toPay(url, params) }]
      );
      // 20211215版本，序号614，取消运费提示弹窗功能
      // } else if (
      //   get(orderParams, 'deliveryType') == 1 &&
      //   this.payAmount < minAmount &&
      //   ([3, 5].includes(+Stores.AppMod.userType))
      // ) {
      //   Modal.alert(
      //     '温馨提示',
      //     `订单金额不满${Util.formatMoney({value: minAmount, showPrefix: false, showCurrencyName: true, precision: 0})}，发货时将产生运费约${Util.formatMoney({value: this.freightAmountForShow, showPrefix: false, showCurrencyName: true, precision: 0})}，会通过店铺扣除运费，请留意`,
      //     [{ text: '确定', onPress: () => this.toPay(url, params) }],
      //   );
    } else {
      params.ment = ment;
      params.activityLink = activityLink;
      this.toPay(url, {
        ...params,
        ...extra
      });
    }
  });

  /**
   * 享包邮产品列表传参字段转换
   * 后端要求参数调整字段值
   */
  // #region 享包邮产品列表传参字段转换
  changeFreeShippingOrderItems() {
    try {
      const list = this.freeShippingItem || [];
      const ls = list.map((l) => ({
        skuNum: 1,
        itemNum: 1,
        itemId: l.itemId,
        itemSerial: l.itemId,
        itemPrice: l.price,
        skuSerial: l.skuSerial,
        groupKey: '1024',
        activityIdList: [],
        benefitId: ''
      }));
      return ls;
    } catch (error) {
      console.log(error, '转换请求参数失败');
      return [];
    }
  }

  /**
   * 创建乐道订单
   *
   * orderType '1'零售订单 '2'复消订单 '3'自主开卡 '4'会员自主升级/会员代客升级 '5'会员新客注册 '6'申请开店 '7'店铺新客注 册 '8'店铺老客升级。 '9': 维多益站点会员代客升级
   *  type 1.自主开卡，2.自主升级，3.代客开卡，4.代客升级
   */
  addLDOrder = flow(function* (isShareOrder) {
    try {
      const itemCode = Util.getLocalCache('ldorder_itemcode');

      const addressMap = {
        1: this.deliveryAddress,
        2: this.pickUpInfo,
        3: this.storeInfo
      };

      const params = {
        itemCode,
        type: this.type,
        deliveryAddress: addressMap[`${this.deliveryType}`],
        deliveryType: this.deliveryType,
        isShareOrder: isShareOrder || false,
        shopCode: this.belongShop || ''
      };
      if (!_.isEmpty(this.ldRegisterCardReqDto)) {
        params.registerCardReqDto = this.ldRegisterCardReqDto;
      }

      if (this.needForm) {
        const newFormInfo = this.cellsForm;

        params.newFormInfo = newFormInfo;
      }

      const { data } = yield Serv.addLDOrder(params);

      if (data) {
        this.resetForm();
        if (isShareOrder) {
          this.updateOrderIsShareOrder(data);
          window.app.routerRedirect(`/shop/payQRCode?tradeNo=${data}&isShopDg=${this.isShopDg}`);
        } else {
          window.app.routerRedirect(`/shop/payMent/${data}`);
        }
      }
    } catch (err) {}
  });

  toPay = flow(function* (url, params = {}) {
    try {
      Toast.loading('请稍候', 100);
      const $params = this.getMoreParams(params);
      const { data, resultCode, resultMsg, extFields } = yield Serv.addOrder(url, $params);
      const { reqId = '' } = extFields || {};
      if (data) {
        localStorage.removeItem('pickUpSelfAddress');
        this.pickUpSelfAddress = null;
        Util.setLocalCache(Config.localStorageKeys.confirm_req_id, ''); // 清除缓存
        if (Stores.AppMod.isCXY || Stores.AppMod.isWY) {
          Util.setLocalCache(Config.localStorageKeys.modifySaleTag, '');
        }
        const { tradeNo } = data || {};
        // 记录 公众号来源上报
        const fromOrigin = sessionStorage.getItem('fromOrigin');
        !!data && !!fromOrigin && this.remberOrigin({ tradeNo: tradeNo || data, fromOrigin });

        if (this.inletTitle) {
          let newTitle = this.inletTitle;
          if (this.inletTitle === 'MRYP') {
            window.sensors.track('dailyOne', {
              type: 4, // type 1,2,3,4  访问、分享、时长、下单
              channal: 'H5',
              isLogin: !!Stores.AppMod.token,
              userId: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.id) || '',
              cardCode: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.cardCode) || '',
              tradeNo: tradeNo || data
            });
          } else {
            if (this.inletTitle.indexOf('复消悬浮条') > -1) {
              let scene = '';
              if (!isNaN(this.inletTitle.charAt(0))) {
                newTitle = this.inletTitle.slice(7);
                scene = this.inletTitle.slice(0, 1);
              } else {
                newTitle = this.inletTitle.slice(6);
              }
              window.sensors.track('otherRecommend', {
                information_title: '复消悬浮条',
                type: 4,
                channal: 'H5',
                scene,
                userId: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.id) || '',
                cardCode: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.cardCode) || '',
                tradeNo: tradeNo || data
              });
            }
            window.sensors.track('userlifeCycle', {
              information_title: newTitle,
              type: 4, // type 1,2,3,4 区分点击、登录、注册、下单
              channal: 'H5',
              isLogin: !!Stores.AppMod.token,
              userId: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.id) || '',
              cardCode: (Stores.AppMod.userInfo && Stores.AppMod.userInfo.cardCode) || '',
              orderNum: tradeNo || data
            });
          }
        }
      }
      // 重新请求顺手买一单
      const resetEasyBuy = (relationKey) => {
        //
        const { orderType, activityIdList, globalSaleMode, dreamPlanRelateCard } =
          this.easeBuyParams || {};
        this.getEaseBuyItemList(orderType, activityIdList, globalSaleMode, {
          dreamPlanRelateCard,
          relationKey
        }).then(() => {
          this.easeBuyModalVisible = true;
        });
      };

      if (localStorage.getItem('noOrderToOpenCard') == 1 && data) {
        // console.log(data,'------66666---->');
        Util.setLocalCache('succCardDataforZero', data);
        localStorage.removeItem('noOrderToOpenCard');
        Toast.hide();
        window.app.routerGoTo('/personal');
        return;
      } else {
        if (resultCode != 0) {
          Toast.hide();
          if (['20800', '20801'].includes(resultCode)) {
            resetEasyBuy(reqId);
          } else {
            Toast.show(resultMsg);
          }

          return;
        }
      }

      Toast.hide();
      this.clearHawEyeInfo();
      if (resultCode != '0') {
        if (resultCode == '8858') {
          // 超过活动库存，弹窗提示
          this.handleActivityOutStock(resultMsg, () => {
            if (data && data.correctReq && data.correctReq.orderItems) {
              this.addOrder(data.correctReq.orderItems, undefined, params.isShareOrder);
            }
          });
        } else if (['20800', '20801'].includes(resultCode)) {
          resetEasyBuy(reqId);
        } else {
          Toast.fail(resultMsg, 3);
        }
      } else {
        if (data) {
          if (localStorage.getItem('needOrderMSZ') == 0) {
            localStorage.removeItem('needOrderMSZ');
            localStorage.removeItem('storeTypeIdMSZ');
            localStorage.removeItem('certificationList');
            window.app.routerGoTo('/personal');
            return;
          }
          this.resetForm();
          let tradeNo = data;
          if (typeof data === 'object') {
            if (data.commonUserZeoYuan) {
              // 普客零元支付
              Util.setLocalCache(Config.localStorageKeys.shop_paySuccData, {
                payNo: data.payResult.tradeNo,
                tradeNo: data.tradeNo
              });
              Util.setLocalCache(
                Config.localStorageKeys.shop_paySuccDiscountAmount,
                data.platformDiscountAmount || 0
              );
              window.app.routerRedirect('/shop/paySuccess');
              return;
            }
            tradeNo = data.tradeNo;
          }
          if (params.isShareOrder) {
            this.updateOrderIsShareOrder(tradeNo);
            window.app.routerRedirect(
              `/shop/payQRCode?tradeNo=${tradeNo}&isShopDg=${this.isShopDg}`
            );
          } else {
            window.app.routerRedirect(
              `/shop/payMent/${tradeNo}?birthday=${this.birthday}&isMb=${params.isMb}`
            );
          }
        }
      }
      if (Util.getLocalCache(Config.localStorageKeys.th_cloud_warehouse)) {
        return resultCode == '0';
      }
    } catch (e) {}
  });

  /**
   * @description 根据分享人的卡号获取分享人的 userId
   */
  getShareUserByCardNo = flow(function* ({ key, value }) {
    try {
      const { data } = yield Serv.getShareUserByCardNo(value);
      if (data) {
        sessionStorage.setItem(key, data);
      }
    } catch (e) {
      console.log(e);
    }
  });

  // 上报来源标识 到订单
  remberOrigin = flow(function* ({ tradeNo, fromOrigin }) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.remberOrigin({
        tradeNo,
        saleChannelKey: fromOrigin
      });
    } catch (error) {}
  });

  // clear鹰眼信息
  clearHawEyeInfo = () => {
    const { valueList, cellsForm } = this;
    let newCellsForm = [...cellsForm];
    valueList.forEach((item) => {
      let newObject = newCellsForm[item];
      delete newObject.hawkEyeTestInfo;
      newCellsForm[item] = newObject;
    });
    this.cellsForm = newCellsForm;
  };

  /**
   * 检测是否可代客支付
   */
  // checkCanPay = flow(function* (tradeNo, openId, cb, isRedirect, cb_fail) {
  //   try {
  //     const {resultCode, data} = (yield Serv.checkCanPay({tradeNo, userId: Stores.AppMod.userInfo.id, openId})) || {};
  //     if (resultCode != 0) {
  //       cb_fail && cb_fail();
  //       return;
  //     }
  //     if (data && data.isOrderStatus) {
  //       if (data.isQrCode && data.isDrawer) {
  //         const url = `/shop/payQRCode?tradeNo=${tradeNo}`;
  //         isRedirect ? window.app.routerRedirect(url) : window.app.routerGoTo(url);
  //       } else {
  //         cb && cb();
  //       }
  //     } else {
  //       Toast.info('该订单无需支付');
  //       cb_fail && cb_fail();
  //     }
  //   } catch (e) {
  //     cb_fail && cb_fail();
  //   }
  // });

  checkICanPay = flow(function* (cb) {
    try {
      const { resultCode, data } =
        (yield Serv.checkCanPay({ userId: Stores.AppMod.userInfo.id })) || {};
      if (resultCode == 0 && data && data.isValetPay) cb && cb();
    } catch (e) {}
  });

  updateOrderIsShareOrder = flow(function* (tradeNo) {
    try {
      yield Serv.updateOrderIsShareOrder(tradeNo);
    } catch (e) {}
  });

  /**
   * 获取订单提醒
   */
  goConfirmTip = flow(function* (callback) {
    let deliveryAddress = ['1', '7', '8'].includes(this.deliveryType)
      ? this.deliveryAddress
      : this.deliveryType == 3
        ? this.storeInfo
        : this.pickUpInfo;
    const params = {
      posType: contentTipPosTypeMap.CONFIRMORDER,
      areaCode: deliveryAddress.areaCode || deliveryAddress.cityCode
    };
    const cheapItemList = this.orderInfo.cheapItemList || [];
    let product = [];
    // 商品
    this.itemList.forEach((item) => {
      if (item.itemSerial) {
        product.push(item.itemSerial);
      }
    });
    // 赠品
    this.giveawayInfoList.forEach((item) => {
      if (item.itemSerial) {
        product.push(item.itemSerial);
      }
    });
    // 加价购
    cheapItemList.forEach((item) => {
      if (item.itemSerial) {
        product.push(item.itemSerial);
      }
    });

    params.product = product.join(',');

    try {
      const { data } = yield Serv.getConfirmTip(params);
      if (data) {
        let list = data;
        // 过滤专题页提示
        list = list
          .filter((item) => item.cueType !== 3)
          .sort((a, b) => {
            // console.log(a, b);
            if (b.priority - a.priority === 0) {
              return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
            }
            return b.priority - a.priority;

            // if (a.priority > b.priority) {
            //   return 1;
            // } else {
            //   return -1;
            // }
          });
        // console.log('confirmTip', list);
        this.confirmTip = list;
        callback && callback(list);
      }
    } catch (e) {
      callback && callback([]);
    }
  });

  /**
   * 秒杀下单 - 创建促销活动订单，返回tk
   * ignoreFreightTips: boolean，是否忽略运费提示
   */
  createPromotionOrder = flow(function* (
    ignoreFreightTips = false,
    activityLink = null,
    addActivityId = null
  ) {
    const params = this.getOrderParams();
    const { confirmReqId = '' } = this.orderInfo || {};
    if (confirmReqId) {
      params.confirmReqId = confirmReqId || ''; // 秒杀参数，昊未新增
    }
    params.shareSource = 1;
    if (activityLink && activityLink != 'undefined') {
      params.bizActivityExclusiveLinkReqDto = {
        activityId: addActivityId,
        activityLink
      };
    }
    if (params.deliveryAddress.deliveryType == 2) {
      // 解密手机号
      if (params.deliveryAddress.deliveryMobile.indexOf('*') != -1) {
        params.deliveryAddress.deliveryMobile = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 206,
          channel: ''
        });
      }
      // 解密姓名
      if (
        params.deliveryAddress.deliveryName &&
        params.deliveryAddress.deliveryName.indexOf('*') != -1
      ) {
        params.deliveryAddress.deliveryName = yield Stores.AppMod.getDecyptMsg({
          id: this.dgUserId || Stores.AppMod.userInfo.id,
          scene: 101,
          channel: ''
        });
      }
    }
    const shareId = localStorage.getItem('shareIdVistor') || undefined;
    params.shareId = shareId;
    let isSmartCard = '';
    if (Stores.AppMod.isSmartCard.id) {
      isSmartCard = Stores.AppMod.isSmartCard;
    }
    if (this.needForm) {
      Object.assign(params, {
        formInfo: {
          certificateName: this.ziGeCertificateName || this.ziGeMemberName,
          dateStr: this.ziGeday,
          dateType: this.ziGedataType,
          mateName: this.ziGePartnerName,
          name: this.ziGeMemberName
        },
        newFormInfo: this.cellsForm
      });
    }
    if (isSmartCard.id) {
      params.saleByBusinessFlag = 1;
      params.shareUserId = isSmartCard.id;
    }
    if (sessionStorage.getItem('subActivityId')) {
      params.subActivityId = sessionStorage.getItem('subActivityId') || '';
    }
    let provinceName = get(params, 'deliveryAddress.provinceName') || '';
    let minAmount =
      provinceName.indexOf('新疆') != -1 || provinceName.indexOf('西藏') != -1 ? 1700 : 500;
    if (
      !ignoreFreightTips &&
      get(params, 'deliveryType') == 1 &&
      this.payAmount < minAmount &&
      ([3, 5].includes(+Stores.AppMod.userType) ||
        [5, 7, 8].includes(+this.orderType) ||
        this.dgMemberInfo)
    ) {
      // Modal操作为异步，需借助Promise，以便调用者取得调用结果
      // return new Promise((resolve, reject) => {
      //   Modal.alert(
      //     '温馨提示',
      //     `订单金额不满${Util.formatMoney({value: minAmount, showPrefix: false, showCurrencyName: true, precision: 0})}，发货时将产生运费约${Util.formatMoney({value: this.freightAmountForShow, showPrefix: false, showCurrencyName: true, precision: 0})}，会通过店铺扣除运费，请留意`,
      //     [{ text: '确定', onPress: () => resolve(this.createPromotionOrder(true)) }],
      //   );
      // })

      // 20211215版本，序号614，取消运费提示弹窗功能
      return this.createPromotionOrder(true, activityLink, addActivityId);
    }
    Toast.loading('请稍候', 100);
    const newParams = this.calParmas({
      val: [
        { key: 'subActivityId', value: 'subActivityId' },
        { key: 'subCardCode', value: 'cardCode' },
        { key: 'subActivityChannel', value: 'subActivityChannel' }
      ],
      params
    });
    const { tk } = yield Serv.createPromotionOrder(newParams);
    // 设置订单类型：9-促销订单
    Util.setLocalCache(Config.localStorageKeys.shop_orderType, '9');
    this.resetForm();
    Toast.hide();
    return tk;
  });

  /**
   * 预售下单 - 创建促销活动订单，返回tk
   * ignoreFreightTips: boolean，是否忽略运费提示
   */
  createAdvanceSaleOrder = flow(function* (
    ignoreFreightTips = false,
    activityLink = null,
    addActivityId = null
  ) {
    const params = this.getOrderParams();
    params.shareSource = 1;
    const shareId = localStorage.getItem('shareIdVistor') || undefined;
    params.shareId = shareId;
    const {
      activityId,
      preSellType,
      payDownPaymentDateStart,
      payDownPaymentDateEnd,
      payFinalPaymentDateStart,
      payFinalPaymentDateEnd,
      unifyPreSellTailPrice
    } = this.activityInfo;
    const { depositDiscountAmount } = this.orderInfo;

    params.depositExpansion = depositDiscountAmount;
    params.payType = preSellType;
    params.activityId = activityId;
    params.depositPayEndtime = payDownPaymentDateEnd;
    params.depositPayStarttime = payDownPaymentDateStart;
    params.tailAmount = unifyPreSellTailPrice;
    params.tailPayEndtime = payFinalPaymentDateEnd;
    params.tailPayStarttime = payFinalPaymentDateStart;
    if (this.tradeNo) {
      params.tradeNo = this.tradeNo;
    }
    if (activityLink && activityLink != 'undefined') {
      params.bizActivityExclusiveLinkReqDto = {
        activityId: addActivityId,
        activityLink
      };
    }

    params.couponList = this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id);
    params.freightCouponList =
      this.selectedFreightCoupon >= 0
        ? [this.freightCouponInfo.usableList[this.selectedFreightCoupon].id]
        : [];
    let isSmartCard = '';
    if (Stores.AppMod.isSmartCard.id) {
      isSmartCard = Stores.AppMod.isSmartCard;
    }
    if (this.needForm) {
      Object.assign(params, {
        formInfo: {
          certificateName: this.ziGeCertificateName || this.ziGeMemberName,
          dateStr: this.ziGeday,
          dateType: this.ziGedataType,
          mateName: this.ziGePartnerName,
          name: this.ziGeMemberName
        },
        newFormInfo: this.cellsForm
      });
    }
    if (isSmartCard.id) {
      params.saleByBusinessFlag = 1;
      params.shareUserId = isSmartCard.id;
    }
    const $deliveryMobile = yield this.getDecyptMsgInfo({
      type: 'phone',
      value: get(params, 'deliveryAddress.deliveryMobile') || ''
    });
    const $deliveryName = yield this.getDecyptMsgInfo({
      type: 'name',
      value: get(params, 'deliveryAddress.deliveryName') || ''
    });
    params.deliveryAddress = {
      ...params.deliveryAddress,
      deliveryMobile: $deliveryMobile,
      deliveryName: $deliveryName
    };
    let provinceName = get(params, 'deliveryAddress.provinceName') || '';
    let minAmount =
      provinceName.indexOf('新疆') != -1 || provinceName.indexOf('西藏') != -1 ? 1700 : 500;
    if (
      (!ignoreFreightTips && [3, 5].includes(+Stores.AppMod.userType)) ||
      (([5, 7, 8].includes(+this.orderType) || this.dgMemberInfo) &&
        get(params, 'deliveryType') == 1 &&
        this.payAmount < minAmount)
    ) {
      // return new Promise((resolve, reject) => {
      //   Modal.alert(
      //     '温馨提示',
      //     `订单金额不满${Util.formatMoney({value: minAmount, showPrefix: false, showCurrencyName: true, precision: 0})}，发货时将产生运费约${Util.formatMoney({value: this.freightAmountForShow, showPrefix: false, showCurrencyName: true, precision: 0})}，会通过店铺扣除运费，请留意`,
      //     [{ text: '确定', onPress: () => resolve(this.createAdvanceSaleOrder(true)) }],
      //   );
      // })

      // 20211215版本，序号614，取消运费提示弹窗功能
      return this.createAdvanceSaleOrder(true, activityLink, addActivityId);
    }
    Toast.loading('请稍候', 100);
    const { tk } = yield Serv.createAdvanceSaleOrder(params);
    // 设置订单类型：7-预售订单
    // Util.setLocalCache(Config.localStorageKeys.shop_orderType, '7');
    this.resetForm();
    Toast.hide();
    return tk;
  });

  /**
   * 团购下单 - 创建促销活动订单，返回tk
   * ignoreFreightTips: boolean，是否忽略运费提示
   */
  createGroupBuyOrder = flow(function* (
    ignoreFreightTips = false,
    activityLink = null,
    addActivityId = null
  ) {
    const params = this.getOrderParams();
    params.shareSource = 1;
    const shareId = localStorage.getItem('shareIdVistor') || undefined;
    params.shareId = shareId;
    const { activityId } = this.activityInfo;

    params.activityId = activityId;
    params.groupActionType = this.groupOrderId
      ? groupActionTypeMap.GROUPWITHOTHER
      : groupActionTypeMap.STARTGROUP;
    params.skuId = this.itemList[0].itemSerial;
    if (this.groupOrderId) {
      params.groupOrderId = this.groupOrderId;
    }

    params.couponList = this.selectedCoupons.map((item) => this.couponInfo.usableList[item].id);
    if (activityLink && activityLink != 'undefined') {
      params.bizActivityExclusiveLinkReqDto = {
        activityId: addActivityId,
        activityLink
      };
    }
    params.freightCouponList =
      this.selectedFreightCoupon >= 0
        ? [this.freightCouponInfo.usableList[this.selectedFreightCoupon].id]
        : [];
    let isSmartCard = '';
    if (Stores.AppMod.isSmartCard.id) {
      isSmartCard = Stores.AppMod.isSmartCard;
    }
    if (this.needForm) {
      Object.assign(params, {
        formInfo: {
          certificateName: this.ziGeCertificateName || this.ziGeMemberName,
          dateStr: this.ziGeday,
          dateType: this.ziGedataType,
          mateName: this.ziGePartnerName,
          name: this.ziGeMemberName
        },
        newFormInfo: this.cellsForm
      });
    }
    if (isSmartCard.id) {
      params.saleByBusinessFlag = 1;
      params.shareUserId = isSmartCard.id;
    }

    // 解密手机号
    if (params.deliveryAddress.deliveryMobile.indexOf('*') != -1) {
      params.deliveryAddress.deliveryMobile = yield Stores.AppMod.getDecyptMsg({
        id: this.dgUserId || Stores.AppMod.userInfo.id,
        scene: 206,
        channel: ''
      });
    }
    // 解密姓名
    if (
      params.deliveryAddress.deliveryName &&
      params.deliveryAddress.deliveryName.indexOf('*') != -1
    ) {
      params.deliveryAddress.deliveryName = yield Stores.AppMod.getDecyptMsg({
        id: this.dgUserId || Stores.AppMod.userInfo.id,
        scene: 101,
        channel: ''
      });
    }

    if (sessionStorage.getItem('subActivityId')) {
      params.subActivityId = sessionStorage.getItem('subActivityId') || '';
    }
    let provinceName = get(params, 'deliveryAddress.provinceName') || '';
    let minAmount =
      provinceName.indexOf('新疆') != -1 || provinceName.indexOf('西藏') != -1 ? 1700 : 500;
    if (
      (!ignoreFreightTips && [3, 5].includes(+Stores.AppMod.userType)) ||
      (([5, 7, 8].includes(+this.orderType) || this.dgMemberInfo) &&
        get(params, 'deliveryType') == 1 &&
        this.payAmount < minAmount)
    ) {
      // return new Promise((resolve, reject) => {
      //   Modal.alert(
      //     '温馨提示',
      //     `订单金额不满${Util.formatMoney({value: minAmount, showPrefix: false, showCurrencyName: true, precision: 0})}，发货时将产生运费约${Util.formatMoney({value: this.freightAmountForShow, showPrefix: false, showCurrencyName: true, precision: 0})}，会通过店铺扣除运费，请留意`,
      //     [{ text: '确定', onPress: () => resolve(this.createGroupBuyOrder(true)) }],
      //   );
      // })

      // 20211215版本，序号614，取消运费提示弹窗功能
      return this.createGroupBuyOrder(true, activityLink, addActivityId);
    }
    Toast.loading('请稍候', 100);
    const { tk } = yield Serv.createGroupBuyOrder(params);
    // 设置订单类型：8-团购订单
    // Util.setLocalCache(Config.localStorageKeys.shop_orderType, '8');
    this.resetForm();
    Toast.hide();
    return tk;
  });

  /**
   * 活动下单 - 查询活动订单下单结果
   */
  searchActivityOrderResult = flow(function* (token) {
    try {
      const result = yield Serv.searchActivityOrderResult(token);
      this.activityOrderResult = result;
    } catch (e) {
      this.activityOrderResult = e;
    }
  });

  /**
   * 活动下单，超出库存处理
   */
  handleActivityOutStock(title = '活动库存限制', resultMsg, callback, activityType) {
    if ([activityTypeMap.flashSale].includes(activityType)) {
      const regex = /【(.*?)】/;
      const match = resultMsg.match(regex);
      console.log(match, 'matchmatchmatch');
      window.showConfirmModal({
        content: `亲爱的顾客，非常抱歉，您心仪的“${match[0]}”已经秒杀完毕。请关注我们的其他秒杀活动，或者尝试其他商品。再次感谢您的支持，祝您生活愉快！`,
        title,
        leftTxt: '返回确认',
        rightTxt: '继续提交',
        onCancelPress: () => {
          if (window.app.router.location.pathname.indexOf('/checkOrder') >= 0) {
            window.app.router.goBack();
          }
        },
        onConfirmPress: () => {
          callback && callback();
        }
      });
    } else {
      alert(title, resultMsg, [
        {
          text: '返回确认',
          onPress: () => {
            if (window.app.router.location.pathname.indexOf('/checkOrder') >= 0) {
              window.app.router.goBack();
            }
          }
        },
        {
          text: '继续提交',
          onPress: () => {
            callback && callback();
          }
        }
      ]);
    }
  }

  /**
   * 活动下单，通用提示处理
   */
  handleActivityCommonTip(title = '提示', resultMsg, callback) {
    alert(title, resultMsg, [
      {
        text: '确认',
        onPress: () => {
          if (window.app.router.location.pathname.indexOf('/checkOrder') >= 0) {
            window.app.router.goBack();
          }
        }
      }
    ]);
  }

  /**
   * 获取顺手买一单商品
   */
  getEaseBuyItemList = flow(function* (
    orderType,
    activityIdList = [],
    globalSaleMode = '',
    extra = { dreamPlanRelateCard: '', relationKey: '' }
  ) {
    if (Number(orderType) !== 1 || this.freeShippingNo) {
      return;
    }
    try {
      let params = {
        orderType,
        orderProperty: this.orderProperty,
        saleMode: globalSaleMode,
        dreamPlanRelateCard: (extra && extra.dreamPlanRelateCard) || '',
        relationKey: (extra && extra.relationKey) || ''
      };
      if (activityIdList.length > 0) {
        params.activityIds = activityIdList.join(',');
      }
      const { resultCode, data } = yield Serv.getEaseBuyItemList(params);
      if (resultCode === '0') {
        this.originalPriceDisplay = data.originalPriceDisplay;
        this.purchaseQuantity = data.purchaseQuantity;
        this.easyBuyCode = data.easyBuyCode;
        this.easeBuyItemList = (data.itemRespDtos || []).filter((item) => {
          if (this.itemList.findIndex((i) => i.itemSerial === item.id) >= 0) {
            return false;
          }
          return true;
        });
      } else {
        this.easyBuyCode = '';
      }
    } catch (error) {
      this.easyBuyCode = '';
    }
  });

  @computed
  get selectedEaseBuyItems() {
    const easeBuyItems = this.easeBuyItemList
      .filter((item) => item.checked)
      .map((item) => ({
        activityIdList: [],
        groupKey: '-1',
        itemNum: 1,
        itemPrice: item.discountPrice || item.price,
        itemSerial: item.id,
        skuSerial: item.skuId
      }));

    return easeBuyItems;
  }

  /**
   * 商品列表，和itemList区别在于添加多一个realMoney字段，表示优惠券后的商品金额
   */
  @computed
  get productList() {
    const { preSellBv, groupBv } = this.orderInfo;
    let newBv = 0;
    switch (this.activityType) {
      case activityTypeMap.advanceSale:
        newBv = preSellBv;
        break;
      case activityTypeMap.groupBuy:
        newBv = groupBv;
        break;
      default:
    }
    let list = this.itemList.map((item) => ({
      ...item,
      realMoney: item.totalDiscountAmount,
      realBv: newBv != 0 ? newBv : Math.floor(item.totalDiscountBv / item.itemNum) * item.itemNum
    }));
    // 循环每种类型优惠券
    const newSelectedCoupons = this.selectedCoupons.sort((a, b) => {
      return (
        this.couponInfo.usableList[a].bvCalculateType -
        this.couponInfo.usableList[b].bvCalculateType
      );
    });
    newSelectedCoupons.forEach((couponIndex) => {
      const coupon = this.couponInfo.usableList[couponIndex];
      let totalAmount = 0;
      // 抵扣券，计算该商品所占“优惠券涉及商品范围内总金额”的比重
      if (coupon && coupon.couponType == 1) {
        list.forEach((product) => {
          if (
            coupon.itemRange == 1 ||
            coupon.itemRange == 6 ||
            coupon.itemIdList.includes(product.itemSerial)
          ) {
            totalAmount += product.realMoney;
          }
        });
      }
      list.forEach((product) => {
        // 如果该优惠券对该商品有优惠，则计算
        if (
          (coupon && coupon.itemRange == 1) ||
          (coupon && coupon.itemRange == 6) ||
          (coupon && coupon.itemIdList.includes(product.itemSerial))
        ) {
          // 抵扣券，直接按比例减去金额和bv即可
          if (coupon.couponType == 1) {
            const preRealMoney = product.realMoney;
            // 需要判断分母totalAmount为0的情况
            product.realMoney -=
              totalAmount == 0
                ? (coupon.couponValue * 100) / 100
                : ((product.realMoney / totalAmount) * coupon.couponValue * 100) / 100;
            if (coupon.bvCalculateType === 2) {
              // bv不变优惠券 则不处理BV显示
            } else {
              // 需要判断分母preRealMoney为0的情况
              product.realBv =
                preRealMoney == 0
                  ? 0
                  : Math.round(((product.realBv * product.realMoney) / preRealMoney) * 100) / 100;
            }
            // bv全减逻辑添加
            if (coupon.bvCalculateType === 0) {
              product.realBv = 0;
            }
          }
          // 折扣券，couponValue是抵扣折扣，需要100来减才是实际打折
          if (coupon.couponType == 2) {
            product.realMoney = (product.realMoney * coupon.couponValue) / 100;
            if (coupon.bvCalculateType === 2) {
              // BV 暂时不做处理
            } else {
              product.realBv = (product.realBv * coupon.couponValue) / 100;
            }
            // bv全减逻辑添加
            if (coupon.bvCalculateType === 0) {
              product.realBv = 0;
            }
          }
          if (coupon.couponType == 5) {
            product.realMoney = 0;
            product.realBv = 0;
          }
          // 每件商品最多只能减到0元
          if (product.realMoney < 0) product.realMoney = 0;
          if (product.realBv < 0) product.realBv = 0;
        }
      });
    });
    return list;
  }

  /**
   * @description 是否使用优惠券BV计算模式
   * bvCalculateType，1-按优惠计算、0-全部减免、2-BV不变
   * 全部减免”或“按优惠计算”， 根据优惠券bv计算
   * @memberof CheckOrderMod
   */
  @computed
  get isUseCouponCalculate() {
    const bvUnchange = 2; // bv 不变

    return (this.selectedCoupons || []).some((couponIndex) => {
      const { usableList = [] } = this.couponInfo || {};

      const { bvCalculateType, couponValue } = usableList[couponIndex] || {};
      return bvCalculateType != bvUnchange && couponValue > 0;
    });
  }

  @computed
  get couponDiscount() {
    const { freightAmount, totalAmount, activityDiscountAmount, cheapAmount } = this.orderInfo;
    let total = [0, ...this.productList].reduce(
      (pre, next) => pre + next.totalDiscountAmount - next.realMoney
    );
    if (
      this.voucherInfo &&
      this.voucherInfo.voucherAssignAmount === 1 &&
      this.voucherInfo.voucherAmount > 0 &&
      this.voucherInfo.voucherAmount < total
    ) {
      total = total - this.voucherInfo.voucherAmount;
    }
    return Math.round(total * 100) / 100;
  }

  @computed
  get dgStatus() {
    if (this.dgMemberInfo) {
      // 0-自购(默认，可不传)，1-店铺代客，2-会员代客
      // 如果是代客的话，按之前的逻辑，默认为 店铺代客
      return this.dgMemberInfo.origin == 'member' ? 2 : 1;
    } else {
      return 0;
    }
  }

  @computed
  get belongShopEditaled() {
    const { userType } = Stores.AppMod;
    // return (
    //   userType < 3 &&
    //   [1, 2].includes(+this.deliveryType) &&
    //   ![3, 4, 5, 6, 7, 8].includes(+this.orderType) &&
    //   !this.dgMemberInfo
    // );

    // 202109，修改“所属店铺”的展示规则
    // 1、会员自购，个人收货或自提（可以修改订单归属成任意店铺）
    // 2、会员代客下单，个人收货或自提（可以修改订单归属成任意店铺）

    let isShow = false;

    // 会员自购
    if (userType == 2 && !this.dgMemberInfo) {
      isShow = true;
    }

    // 会员，进行“会员代客下单”
    const { origin } = this.dgMemberInfo || {};
    if (userType == 2 && !!this.dgMemberInfo && origin == 'member') {
      isShow = true;
    }

    // 控制是否显示
    if (!isShow) {
      return false;
    }

    // 仅个人收货 或 自提，才显示
    if ([1, 2].includes(+this.deliveryType)) {
      return true;
    }

    return false;
  }

  // 确认提交按钮不可点
  @computed
  get disabled() {
    if (this.isCellMode) {
      return false;
    }
    return (
      this.needForm &&
      (!`${this.ziGeMemberName}` ||
        !this.ziGeday ||
        (!this.isSelected && !`${this.ziGeCertificateName}`) ||
        (this.ziGedataType == 0 && !`${this.ziGePartnerName}`))
    );
  }

  @computed
  get isShopDg() {
    // return false;
    let flag = false;

    // 1普客、2会员、3店长、5子账号
    const { userType } = Stores.AppMod;

    // 订单类型 1：零售订单 2：月销订单 3: 开卡订单 4: 升级订单 5 开店订单、 6 促销订单
    const orderType = this.orderType;

    // 代客下单的客卡号
    const dgMemberCode = (this.dgMemberInfo && this.dgMemberInfo.memberCard) || '';

    // （1-1）店铺代客开卡
    const shop3Flag = orderType == 7 && (userType == 3 || userType == 5);

    // （1-2）店铺代客升级
    const shop4Flag =
      (orderType == 8 && userType == 5) || (orderType == 8 && userType == 3 && !!this.dgUserId);

    // （1-3）店铺代客下单
    const shopDgFlag = (userType == 3 || userType == 5) && !!dgMemberCode;

    console.log(`ConfirmOrderMobx - shop3Flag = ${shop3Flag}`);
    console.log(`ConfirmOrderMobx - shop4Flag = ${shop4Flag}`);
    console.log(`ConfirmOrderMobx - shopDgFlag = ${shopDgFlag}`);
    console.log(shop3Flag);
    console.log(shop4Flag);
    console.log(shopDgFlag);
    console.log('>>>>>>>>>>>>>>>>>>>');
    // （1-4）判断店铺代客场景
    flag = shop3Flag || shop4Flag || shopDgFlag;

    return flag;
  }

  /**
   * 活动下单 - 查询活动订单下单结果
   */
  searchActivityOrderResult = flow(function* (token) {
    try {
      const result = yield Serv.searchActivityOrderResult(token);
      this.activityOrderResult = result;
    } catch (e) {
      this.activityOrderResult = e;
    }
  });

  /**
   * 是否包含AI检测产品
   */
  getHasAIDetectionProduct = flow(function* () {
    try {
      // 商品对应的code(包含组合商品及其子产品的code)
      const itemCodeList = (toJS(this.itemList) || []).flatMap((item) => {
        const codes = [item.code];
        if (item.child && Array.isArray(item.child)) {
          codes.push(...item.child.map((childItem) => childItem.code).filter(Boolean));
        }
        return codes;
      });
      const {
        cheapItemList = [],
        giveawayInfoList = [],
        randomCheapItemList = [],
        randomGiftList = []
      } = this.confirmReturnData;
      const getCodeList = (list, filterFn = () => true, fieldName = 'itemCode') =>
        (list || [])
          .filter(filterFn)
          .map((item) => item[fieldName])
          .filter(Boolean);
      // 顺手买一单对应的商品code
      const easebuyCodeList = getCodeList(this.easeBuyItemList, (item) => item.checked, 'code');
      // 满赠赠品对应的商品code
      const freeItemCodeList = getCodeList(giveawayInfoList || []);
      // 加价购加购品对应的code
      const cheapItemCodeList = getCodeList(cheapItemList || []);
      // 福袋赠品对应的商品code
      const randomFreeItemCodeList = getCodeList(randomGiftList || []);
      // 福袋加购品对应的商品code
      const randomCheapItemCodeList = getCodeList(randomCheapItemList || []);

      const codeList = [
        ...itemCodeList,
        ...easebuyCodeList,
        ...freeItemCodeList,
        ...cheapItemCodeList,
        ...randomFreeItemCodeList,
        ...randomCheapItemCodeList
      ];

      const result = yield Serv.getHasAIDetectionProduct(codeList);
      if (result && result.resultCode === '0') {
        if (result.data && result.data.exists) {
          this.detectionModal = {
            visible: true,
            tip: result.data.label
          };
          return true;
        }
      }
      return false;
    } catch (e) {
      return false;
    }
  });

  verifyMemberChangeStatus = flow(function* (params) {
    try {
      const result = yield Serv.verifyMemberChangeStatus(params);
      return result;
      // this.activityOrderResult = result;
    } catch (e) {
      // this.activityOrderResult = e;
    }
  });

  queryOrderRemark = flow(function* (goodsCouponTag) {
    try {
      const params = this.getOrderParams();
      console.log(toJS(params), 'itemListitemListitemList3242342');
      const lirty = this.getAddOrderItems('');
      console.log(toJS(lirty), 'lirtylirtylirtylirtylirty');
      const { orderItems } = params || {};
      const itemCodeList =
        Array.isArray(toJS(orderItems)) &&
        orderItems.length > 0 &&
        orderItems.map((res) => {
          const { code } = res || {};
          return code;
        });
      console.log(itemCodeList.join(','), '00000000');
      const requsetParams = {
        belongSystem: Stores.AppMod.userInfo ? Stores.AppMod.userInfo.belongSystem : '',
        itemCodeList: itemCodeList.join(',')
      };
      // 提货券
      if (goodsCouponTag && goodsCouponTag !== 'undefined') {
        requsetParams.goodsCouponTag = goodsCouponTag;
      }
      const result = yield Serv.queryOrderRemark(requsetParams);
      if (result && result.resultCode === '0') {
        this.showOrderRemark = !!result.data;
        this.orderRemark = result.data;
      }
    } catch (error) {
      this.showOrderRemark = false;
      this.orderRemark = '';
    }
  });

  getStorePolicyConfig = flow(function* () {
    try {
      const applyStoreMsg = Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg) || {};
      const { storeTypeId } = applyStoreMsg.shopContactInfoDto || {};
      if (storeTypeId) {
        const result = yield Serv.getStorePolicyConfig({ storeTypeId });
        if (result.resultCode == 0 && result.data) {
          return result.data;
        }
        return {};
      }
    } catch (e) {
      return {};
    }
  });

  queryAccumulateCardType = flow(function* (params) {
    try {
      const { data } = yield Serv.queryAccumulateCardType(params);
      return data;
    } catch (error) {
      console.log(error);
    }
  });

  // 是否显示修改服务中心，0-否、1-是
  confirmOrderOptionalInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.confirmOrderOptionalInfo(params);
      this.showModifyServiceCenter = data.showModifyServiceCenter;
    } catch (error) {
      console.log(error);
    }
  });

  @action
  reset() {
    console.log('___reset___');
    this.deduction = [];
    this.deliveryType = '';
    this.deliveryList = [];
    this.deliveryAddress = null;
    this.orderInfo = defaultOrderInfo;
    this.itemList = [];
    this.cellsForm = [];
    this.orderProperty = '1';
    this.discount = '';
    this.hasRequest = false;
    this.pickUpInfo = {};
    this.storeInfo = {};
    this.activityOrderResult = null;
    this.dgMemberInfo = null;
    this.activityInfo = null;
    this.dgCardCode = '';
    this.dgUserId = '';
    this.giveawayInfoList = [];
    this.tradeNo = '';
    this.advanceSaleStatus = '';
    this.activityId = '';
    this.groupOrderId = null;
    this.tradeNo = '';
    this.isVipRebuy = false;
    this.freightAmountForShow = 0;
    this.isAgree = false;
    this.agreenMentCode = '';
    this.agreementTitle = '';
    this.bvReceiveData = {};
    this.ldOrder = false;
    this.ldRegisterCardReqDto = {};
    this.type = '';
    this.showOrderRemark = false;
    this.orderRemark = '';
    this.easeBuyItemList = [];
    this.easeBuyItemIndex = 0;
    this.isFromSelectMall = false;
    this.renewGiftOrderFlag = '';
    this.isBean = false;
    this.specialAddressProductCode = [];
    this.sourceNo = '';
    this.isXBLPickUpGoods = false;
    this.qualifyCoupon = false;
    this.defaultAddressInfo = {};
    this.pickUpSelfAddress = null;
    this.freeShippingNo = '';
    this.globalSaleMode = '';
    this.internationalFreightType = '';
    this.isPriaItem = false;
    this.voucherInfo = {};
    this.isXkcActivity = false;
    this.detectionModal = {
      visible: false,
      tip: ''
    };
    this.detectionRechargeCardCode = '';
  }

  @action
  resetForm() {
    this.needForm = false;
    this.cellsForm = [];
    this.ziGedataType = '1';
    this.ziGeMemberName = '';
    this.ziGePartnerName = '';
    this.ziGeday = '';
    this.isSelected = true;
    this.isShowConfirmTip = false;
    this.ziGeCertificateName = '';
  }
}

const checkOrderMod = new CheckOrderMod();
export default checkOrderMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/CheckOrder/CheckOrderMod.js